import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/blog',
    component: ComponentCreator('/blog', '98b'),
    exact: true
  },
  {
    path: '/bookmarks',
    component: ComponentCreator('/bookmarks', 'bbe'),
    exact: true
  },
  {
    path: '/categories',
    component: ComponentCreator('/categories', '96b'),
    exact: true
  },
  {
    path: '/compass',
    component: ComponentCreator('/compass', 'ae7'),
    exact: true
  },
  {
    path: '/history',
    component: ComponentCreator('/history', '703'),
    exact: true
  },
  {
    path: '/mahalaya',
    component: ComponentCreator('/mahalaya', 'be7'),
    exact: true
  },
  {
    path: '/markdown-page',
    component: ComponentCreator('/markdown-page', '3d7'),
    exact: true
  },
  {
    path: '/muhurt',
    component: ComponentCreator('/muhurt', '7f9'),
    exact: true
  },
  {
    path: '/offline',
    component: ComponentCreator('/offline', '03a'),
    exact: true
  },
  {
    path: '/panchang',
    component: ComponentCreator('/panchang', 'acd'),
    exact: true
  },
  {
    path: '/search',
    component: ComponentCreator('/search', 'e09'),
    exact: true
  },
  {
    path: '/settings',
    component: ComponentCreator('/settings', 'eb4'),
    exact: true
  },
  {
    path: '/updates',
    component: ComponentCreator('/updates', 'e07'),
    exact: true
  },
  {
    path: '/',
    component: ComponentCreator('/', '2e1'),
    exact: true
  },
  {
    path: '/',
    component: ComponentCreator('/', '9ed'),
    routes: [
      {
        path: '/',
        component: ComponentCreator('/', '086'),
        routes: [
          {
            path: '/',
            component: ComponentCreator('/', 'ad7'),
            routes: [
              {
                path: '/1008-kakaradi-sri-kali-sahasranamavali',
                component: ComponentCreator('/1008-kakaradi-sri-kali-sahasranamavali', '0cb'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/1008-sri-bagalamukhi-sahasranamavali',
                component: ComponentCreator('/1008-sri-bagalamukhi-sahasranamavali', 'a41'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/1008-sri-bala-tripura-sundari-sahasranamavali-2',
                component: ComponentCreator('/1008-sri-bala-tripura-sundari-sahasranamavali-2', '7a4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/1008-sri-dakshinamurthy-sahasranamavali',
                component: ComponentCreator('/1008-sri-dakshinamurthy-sahasranamavali', '668'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/1008-sri-gayatri-sahasranama-stotram-2',
                component: ComponentCreator('/1008-sri-gayatri-sahasranama-stotram-2', 'c4c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/1008-sri-gayatri-sahasranama-stotram-in-hindi',
                component: ComponentCreator('/1008-sri-gayatri-sahasranama-stotram-in-hindi', '236'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/1008-sri-lakshmi-sahasranamavali-in-hindi',
                component: ComponentCreator('/1008-sri-lakshmi-sahasranamavali-in-hindi', 'd76'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/1008-sri-maha-ganapati-sahasranamavali',
                component: ComponentCreator('/1008-sri-maha-ganapati-sahasranamavali', '9f5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/1008-sri-pratyangira-sahasranamavali',
                component: ComponentCreator('/1008-sri-pratyangira-sahasranamavali', 'f14'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/1008-sri-saraswati-sahasranamavali',
                component: ComponentCreator('/1008-sri-saraswati-sahasranamavali', '5e3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/1008-sri-subrahmanya-sahasranamavali',
                component: ComponentCreator('/1008-sri-subrahmanya-sahasranamavali', '704'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/1008-sri-varahi-sahasranamavali',
                component: ComponentCreator('/1008-sri-varahi-sahasranamavali', 'adc'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-1-sri-adilakshmi-ashtottara-shatanamavali',
                component: ComponentCreator('/108-1-sri-adilakshmi-ashtottara-shatanamavali', 'd01'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-2-sri-dhanyalakshmi-ashtottara-shatanamavali',
                component: ComponentCreator('/108-2-sri-dhanyalakshmi-ashtottara-shatanamavali', '2be'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-3-sri-dhairyalakshmi-ashtottara-shatanamavali',
                component: ComponentCreator('/108-3-sri-dhairyalakshmi-ashtottara-shatanamavali', '96d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-4-sri-gajalakshmi-ashtottara-shatanamavali',
                component: ComponentCreator('/108-4-sri-gajalakshmi-ashtottara-shatanamavali', 'eb9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-5-sri-santanalakshmi-ashtottara-shatanamavali',
                component: ComponentCreator('/108-5-sri-santanalakshmi-ashtottara-shatanamavali', '68c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-6-sri-vijayalakshmi-ashtottara-shatanamavali',
                component: ComponentCreator('/108-6-sri-vijayalakshmi-ashtottara-shatanamavali', '117'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-7-sri-vidyalakshmi-ashtottara-shatanamavali',
                component: ComponentCreator('/108-7-sri-vidyalakshmi-ashtottara-shatanamavali', 'f4e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-8-sri-aishwaryalakshmi-ashtottara-shatanamavali',
                component: ComponentCreator('/108-8-sri-aishwaryalakshmi-ashtottara-shatanamavali', '77d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-ardhanarishvara-ashtottara-shatanamavali',
                component: ComponentCreator('/108-ardhanarishvara-ashtottara-shatanamavali', 'd17'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-ashtalakshmi-ashtottara-shatanamavali',
                component: ComponentCreator('/108-ashtalakshmi-ashtottara-shatanamavali', 'b63'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-devi-vaibhava-ashcharya-ashtottara-shatanamavali',
                component: ComponentCreator('/108-devi-vaibhava-ashcharya-ashtottara-shatanamavali', 'cc8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-saubhagya-ashtottara-shatanamavali',
                component: ComponentCreator('/108-saubhagya-ashtottara-shatanamavali', 'aba'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-annapurna-ashtottara-satanamavali',
                component: ComponentCreator('/108-sri-annapurna-ashtottara-satanamavali', '279'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-bagalamukhi-ashtottara-shatanamavali',
                component: ComponentCreator('/108-sri-bagalamukhi-ashtottara-shatanamavali', 'f30'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-bagalamukhi-ashtottara-shatanamavali-1-rudrayamale',
                component: ComponentCreator('/108-sri-bagalamukhi-ashtottara-shatanamavali-1-rudrayamale', '65b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-bala-ashtottara-shatanamavali-2',
                component: ComponentCreator('/108-sri-bala-ashtottara-shatanamavali-2', '113'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-bala-tripura-sundari-ashtottara-satanamavali',
                component: ComponentCreator('/108-sri-bala-tripura-sundari-ashtottara-satanamavali', '13f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-bhadrakali-ashtottara-shatanamavali',
                component: ComponentCreator('/108-sri-bhadrakali-ashtottara-shatanamavali', 'b38'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-bhuvaneshwari-ashtottara-shatanamavali',
                component: ComponentCreator('/108-sri-bhuvaneshwari-ashtottara-shatanamavali', 'c1a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-brahma-ashtottara-shatanamavali',
                component: ComponentCreator('/108-sri-brahma-ashtottara-shatanamavali', '54f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-buddhi-devi-ashtottara-shatanamavali',
                component: ComponentCreator('/108-sri-buddhi-devi-ashtottara-shatanamavali', '1be'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-chamundeshwari-ashtottara-shatanamavali',
                component: ComponentCreator('/108-sri-chamundeshwari-ashtottara-shatanamavali', '9cd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-chinnamasta-ashtottara-shatanamavali',
                component: ComponentCreator('/108-sri-chinnamasta-ashtottara-shatanamavali', 'd1c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-dakshinamurthy-ashtottara-shatanamavali',
                component: ComponentCreator('/108-sri-dakshinamurthy-ashtottara-shatanamavali', '5bc'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-dakshinamurthy-mantrarna-ashtottara-shatanamavali',
                component: ComponentCreator('/108-sri-dakshinamurthy-mantrarna-ashtottara-shatanamavali', '741'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-devasena-ashtottara-shatanamavali',
                component: ComponentCreator('/108-sri-devasena-ashtottara-shatanamavali', 'a82'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-devasena-ashtottara-shatanamavali-variation',
                component: ComponentCreator('/108-sri-devasena-ashtottara-shatanamavali-variation', '65c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-dhumavati-ashtottara-shatanamavali',
                component: ComponentCreator('/108-sri-dhumavati-ashtottara-shatanamavali', '8ab'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-durga-ashtottara-satanamavali-1',
                component: ComponentCreator('/108-sri-durga-ashtottara-satanamavali-1', 'd0c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-durga-ashttotara-satanamavali-2',
                component: ComponentCreator('/108-sri-durga-ashttotara-satanamavali-2', 'de7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-ganapati-gakara-ashtottara-shatanamavali',
                component: ComponentCreator('/108-sri-ganapati-gakara-ashtottara-shatanamavali', '70f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-ganesha-ashtottara-shatanamavali',
                component: ComponentCreator('/108-sri-ganesha-ashtottara-shatanamavali', '767'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-ganesha-gakara-ashtottara-shatanamavali',
                component: ComponentCreator('/108-sri-ganesha-gakara-ashtottara-shatanamavali', 'ec0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-gayathri-ashtottara-satanamavali-in-hindi',
                component: ComponentCreator('/108-sri-gayathri-ashtottara-satanamavali-in-hindi', '10d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-gayatri-ashtottara-shatanamavali-1',
                component: ComponentCreator('/108-sri-gayatri-ashtottara-shatanamavali-1', 'ace'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-godadevi-ashtottara-shatanamavali',
                component: ComponentCreator('/108-sri-godadevi-ashtottara-shatanamavali', 'ce8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-harihara-ashtottara-shatanamavali-in-hindi',
                component: ComponentCreator('/108-sri-harihara-ashtottara-shatanamavali-in-hindi', 'ffe'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-indira-ashtottara-shatanamavali',
                component: ComponentCreator('/108-sri-indira-ashtottara-shatanamavali', '468'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-kalabhairava-kakara-ashtottara-shatanamavali',
                component: ComponentCreator('/108-sri-kalabhairava-kakara-ashtottara-shatanamavali', '193'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-kali-ashtottara-shatanamavali',
                component: ComponentCreator('/108-sri-kali-ashtottara-shatanamavali', 'fa8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-kamakshi-ashtottara-shatanamavali',
                component: ComponentCreator('/108-sri-kamakshi-ashtottara-shatanamavali', '46b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-kamala-ashtottara-shatanamavali',
                component: ComponentCreator('/108-sri-kamala-ashtottara-shatanamavali', '407'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-lakshmi-ashtottara-shatanamavali-3',
                component: ComponentCreator('/108-sri-lakshmi-ashtottara-shatanamavali-3', '847'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-lalitha-ashtottara-satanamavali-in-hindi',
                component: ComponentCreator('/108-sri-lalitha-ashtottara-satanamavali-in-hindi', '5f4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-lalitha-ashtottara-shatanamavali-2',
                component: ComponentCreator('/108-sri-lalitha-ashtottara-shatanamavali-2', '6c6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-mahalakshmi-ashtottara-shatanamavali',
                component: ComponentCreator('/108-sri-mahalakshmi-ashtottara-shatanamavali', '6b2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-mahalakshmi-ashtottara-shatanamavali-2',
                component: ComponentCreator('/108-sri-mahalakshmi-ashtottara-shatanamavali-2', '6b6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-mahishasura-mardini-ashtottara-satanamavali',
                component: ComponentCreator('/108-sri-mahishasura-mardini-ashtottara-satanamavali', '95b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-mangala-gauri-ashtottara-shatanamavali',
                component: ComponentCreator('/108-sri-mangala-gauri-ashtottara-shatanamavali', 'c8a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-matangi-ashtottara-shatanamavali',
                component: ComponentCreator('/108-sri-matangi-ashtottara-shatanamavali', '6d1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-padmavathi-ashtottara-satanamavali',
                component: ComponentCreator('/108-sri-padmavathi-ashtottara-satanamavali', '6bb'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-pratyangira-ashtottara-shatanamavali',
                component: ComponentCreator('/108-sri-pratyangira-ashtottara-shatanamavali', 'df8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-rajarajeshwari-ashtottara-satanamavali',
                component: ComponentCreator('/108-sri-rajarajeshwari-ashtottara-satanamavali', '6ae'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-saraswathi-ashtottara-satanamavali',
                component: ComponentCreator('/108-sri-saraswathi-ashtottara-satanamavali', '2c5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-saubhagya-lakshmi-ashtottara-shatanamavali-in-hindi',
                component: ComponentCreator('/108-sri-saubhagya-lakshmi-ashtottara-shatanamavali-in-hindi', 'c50'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-shiva-ashtottara-satanamavali-in-hindi',
                component: ComponentCreator('/108-sri-shiva-ashtottara-satanamavali-in-hindi', '5da'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-shodashi-ashtottara-shatanamavali',
                component: ComponentCreator('/108-sri-shodashi-ashtottara-shatanamavali', 'f0e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-shyamala-ashtottara-shatanamavali',
                component: ComponentCreator('/108-sri-shyamala-ashtottara-shatanamavali', '4c4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-shyamala-ashtottara-shatanamavali-2',
                component: ComponentCreator('/108-sri-shyamala-ashtottara-shatanamavali-2', 'd7f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-siddhi-devi-ashtottara-shatanamavali',
                component: ComponentCreator('/108-sri-siddhi-devi-ashtottara-shatanamavali', '6d1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-subrahmanya-ashtottara-satanamavali',
                component: ComponentCreator('/108-sri-subrahmanya-ashtottara-satanamavali', '965'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-suktha-ashtottara-shatanamavali',
                component: ComponentCreator('/108-sri-suktha-ashtottara-shatanamavali', 'df7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-tara-ashtottara-shatanamavali',
                component: ComponentCreator('/108-sri-tara-ashtottara-shatanamavali', '5dc'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-tripura-bhairavi-ashtottara-shatanamavali',
                component: ComponentCreator('/108-sri-tripura-bhairavi-ashtottara-shatanamavali', '994'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-uma-ashtottara-shatanamavali',
                component: ComponentCreator('/108-sri-uma-ashtottara-shatanamavali', '04c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-valli-ashtottara-shatanamavali',
                component: ComponentCreator('/108-sri-valli-ashtottara-shatanamavali', 'd7b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-valli-ashtottara-shatanamavali-variation',
                component: ComponentCreator('/108-sri-valli-ashtottara-shatanamavali-variation', '8c9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-varada-ganesha-ashtottara-shatanamavali',
                component: ComponentCreator('/108-sri-varada-ganesha-ashtottara-shatanamavali', '732'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-varahi-ashtottara-shatanamavali',
                component: ComponentCreator('/108-sri-varahi-ashtottara-shatanamavali', 'a02'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-varahi-ashtottara-shatanamavali-2',
                component: ComponentCreator('/108-sri-varahi-ashtottara-shatanamavali-2', '114'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-vasavi-ashttotara-shatanamavali-in-hindi',
                component: ComponentCreator('/108-sri-vasavi-ashttotara-shatanamavali-in-hindi', '16e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-vidya-ganesha-ashtottara-shatanamavali',
                component: ComponentCreator('/108-sri-vidya-ganesha-ashtottara-shatanamavali', '0b5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-sri-vighneshwara-ashtottara-shatanamavali',
                component: ComponentCreator('/108-sri-vighneshwara-ashtottara-shatanamavali', 'c0f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/108-subrahmanya-shadakshara-ashtottara-shatanamavali',
                component: ComponentCreator('/108-subrahmanya-shadakshara-ashtottara-shatanamavali', '09c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/300-sri-bala-trishati-namavali',
                component: ComponentCreator('/300-sri-bala-trishati-namavali', '457'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/300-sri-dakshina-kali-trishati-namavali',
                component: ComponentCreator('/300-sri-dakshina-kali-trishati-namavali', 'eaf'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/300-sri-maha-ganapati-trishati-namavali',
                component: ComponentCreator('/300-sri-maha-ganapati-trishati-namavali', '040'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/300-sri-medha-dakshinamurthy-trishati-namavali',
                component: ComponentCreator('/300-sri-medha-dakshinamurthy-trishati-namavali', '77a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/300-sri-subrahmanya-mantra-sammelana-trisati',
                component: ComponentCreator('/300-sri-subrahmanya-mantra-sammelana-trisati', '007'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/300-sri-subrahmanya-trishati-namavali',
                component: ComponentCreator('/300-sri-subrahmanya-trishati-namavali', '44c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/300-sri-subrahmanya-trishati-stotram',
                component: ComponentCreator('/300-sri-subrahmanya-trishati-stotram', '4b6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/aaigiri-nandini',
                component: ComponentCreator('/aaigiri-nandini', '5d5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/aarambhi-vandin',
                component: ComponentCreator('/aarambhi-vandin', '181'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/aata-kothe',
                component: ComponentCreator('/aata-kothe', '124'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/aayushya-sukta',
                component: ComponentCreator('/aayushya-sukta', '28f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/adhik-dekhane',
                component: ComponentCreator('/adhik-dekhane', '6ac'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/aditya-ranubai-devanchi-kahani',
                component: ComponentCreator('/aditya-ranubai-devanchi-kahani', '116'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/all-gayatri',
                component: ComponentCreator('/all-gayatri', '81b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/anant-aarati',
                component: ComponentCreator('/anant-aarati', '4b4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/annapurna',
                component: ComponentCreator('/annapurna', 'f0d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/annapurna-aarat',
                component: ComponentCreator('/annapurna-aarat', '08f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/anureniya-thodka',
                component: ComponentCreator('/anureniya-thodka', '347'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/audio-bhajan-radha',
                component: ComponentCreator('/audio-bhajan-radha', '6af'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/audio-hanuman-bhajan',
                component: ComponentCreator('/audio-hanuman-bhajan', '6df'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/bala-dasavidyamayi-bala-stotram',
                component: ComponentCreator('/bala-dasavidyamayi-bala-stotram', 'c22'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/bala-duswapna-nashaka-bala-kavacham',
                component: ComponentCreator('/bala-duswapna-nashaka-bala-kavacham', '1b0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/bala-sri-bala-ashtottara-shatanama-stotram-2',
                component: ComponentCreator('/bala-sri-bala-ashtottara-shatanama-stotram-2', 'ce3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/bala-sri-bala-bhujanga-stotram',
                component: ComponentCreator('/bala-sri-bala-bhujanga-stotram', 'ace'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/bala-sri-bala-karpura-stotram',
                component: ComponentCreator('/bala-sri-bala-karpura-stotram', '3f6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/bala-sri-bala-mantrakshara-stotram',
                component: ComponentCreator('/bala-sri-bala-mantrakshara-stotram', 'a8d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/bala-sri-bala-muktavali-stotram',
                component: ComponentCreator('/bala-sri-bala-muktavali-stotram', '899'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/bala-sri-bala-panchachamara-stava',
                component: ComponentCreator('/bala-sri-bala-panchachamara-stava', '07f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/bala-sri-bala-sahasranama-stotram',
                component: ComponentCreator('/bala-sri-bala-sahasranama-stotram', '5cc'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/bala-sri-bala-shanti-stotram',
                component: ComponentCreator('/bala-sri-bala-shanti-stotram', 'a67'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/bala-sri-bala-trailokya-vijaya-kavacham',
                component: ComponentCreator('/bala-sri-bala-trailokya-vijaya-kavacham', '573'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/bala-sri-bala-tripurasundari-sahasranama-stotram-2',
                component: ComponentCreator('/bala-sri-bala-tripurasundari-sahasranama-stotram-2', '5c4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/balaji-chalisa',
                component: ComponentCreator('/balaji-chalisa', '341'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/balashish-stotra',
                component: ComponentCreator('/balashish-stotra', '5d8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/balumama-aarati',
                component: ComponentCreator('/balumama-aarati', '2f0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/batuka-bhairav-chalisa',
                component: ComponentCreator('/batuka-bhairav-chalisa', '60c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/bhagvatgeeta',
                component: ComponentCreator('/bhagvatgeeta', '226'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/bhairav-chalisa',
                component: ComponentCreator('/bhairav-chalisa', '09d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/bhairava-aishwaryadayaka-batuka-bhairava-kavacham',
                component: ComponentCreator('/bhairava-aishwaryadayaka-batuka-bhairava-kavacham', '826'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/bhairava-ashta-bhairava-dhyana-stotram',
                component: ComponentCreator('/bhairava-ashta-bhairava-dhyana-stotram', 'ce3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/bhairava-chatushashti-64-bhairava-namavali-stotram',
                component: ComponentCreator('/bhairava-chatushashti-64-bhairava-namavali-stotram', 'f3c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/bhairava-kalabhairavashtakam',
                component: ComponentCreator('/bhairava-kalabhairavashtakam', '800'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/bhairava-sri-batuka-bhairava-brahma-kavacham',
                component: ComponentCreator('/bhairava-sri-batuka-bhairava-brahma-kavacham', '680'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/bhairava-sri-batuka-bhairava-kavacham',
                component: ComponentCreator('/bhairava-sri-batuka-bhairava-kavacham', '829'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/bhairava-sri-batuka-bhairava-sahasranama-stotram-bhairava-tantram',
                component: ComponentCreator('/bhairava-sri-batuka-bhairava-sahasranama-stotram-bhairava-tantram', 'dbc'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/bhairava-sri-batuka-bhairava-stavaraja-ashtottara-shatanama-stotram-cha',
                component: ComponentCreator('/bhairava-sri-batuka-bhairava-stavaraja-ashtottara-shatanama-stotram-cha', 'f63'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/bhairava-sri-bhairava-tandava-stotram',
                component: ComponentCreator('/bhairava-sri-bhairava-tandava-stotram', '4ac'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/bhairava-sri-kala-bhairava-ashtakam-2',
                component: ComponentCreator('/bhairava-sri-kala-bhairava-ashtakam-2', 'b28'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/bhairava-sri-kala-bhairava-pancharatna-stuti',
                component: ComponentCreator('/bhairava-sri-kala-bhairava-pancharatna-stuti', 'f83'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/bhairava-sri-kalabhairava-kakara-ashtottara-shatanama-stotram',
                component: ComponentCreator('/bhairava-sri-kalabhairava-kakara-ashtottara-shatanama-stotram', '528'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/bhairava-sri-maha-kala-bhairava-kavacham-rudrayamale',
                component: ComponentCreator('/bhairava-sri-maha-kala-bhairava-kavacham-rudrayamale', 'f33'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/bhairava-sri-nagna-bhairava-stuti-mudgala-purane',
                component: ComponentCreator('/bhairava-sri-nagna-bhairava-stuti-mudgala-purane', '028'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/bhairava-sri-swarna-akarshana-bhairava-stotram-2',
                component: ComponentCreator('/bhairava-sri-swarna-akarshana-bhairava-stotram-2', '48c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/bhairava-sri-swarna-akarshana-bhairava-stotram-in-hindi',
                component: ComponentCreator('/bhairava-sri-swarna-akarshana-bhairava-stotram-in-hindi', '7e8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/bhairava-sri-swarnakarshana-bhairava-mantramaya-stotram',
                component: ComponentCreator('/bhairava-sri-swarnakarshana-bhairava-mantramaya-stotram', 'c93'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/bhairava-teekshna-danshtra-kalabhairava-ashtakam',
                component: ComponentCreator('/bhairava-teekshna-danshtra-kalabhairava-ashtakam', '126'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/bhairavnath',
                component: ComponentCreator('/bhairavnath', 'e35'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/bhavanya-ashtak',
                component: ComponentCreator('/bhavanya-ashtak', '5b9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/bhimrupi',
                component: ComponentCreator('/bhimrupi', 'b2a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/bhuvan-sundar',
                component: ComponentCreator('/bhuvan-sundar', '12f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/brahma-abhistada-sri-brahma-stotram',
                component: ComponentCreator('/brahma-abhistada-sri-brahma-stotram', 'c67'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/brahma-chalisa',
                component: ComponentCreator('/brahma-chalisa', 'c16'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/brahma-sri-brahma-kavacham-jaganmangalam',
                component: ComponentCreator('/brahma-sri-brahma-kavacham-jaganmangalam', 'ebd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/brahma-sri-brahma-kavacham-rudra-krutam',
                component: ComponentCreator('/brahma-sri-brahma-kavacham-rudra-krutam', '88e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/brahma-sri-brahma-pancharatna-stotram-mahanirvana-tantre',
                component: ComponentCreator('/brahma-sri-brahma-pancharatna-stotram-mahanirvana-tantre', 'f0c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/brahma-sri-brahma-stavam-padmapurane-vishnu-krutam',
                component: ComponentCreator('/brahma-sri-brahma-stavam-padmapurane-vishnu-krutam', 'dd2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/brahma-sri-brahma-stotram-2-deva-krutam',
                component: ComponentCreator('/brahma-sri-brahma-stotram-2-deva-krutam', '896'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/brahma-sri-brahma-stotram-hiranyakashipu-krutam',
                component: ComponentCreator('/brahma-sri-brahma-stotram-hiranyakashipu-krutam', '731'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/brahma-sri-brahma-stuti',
                component: ComponentCreator('/brahma-sri-brahma-stuti', '084'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/brahma-sri-brahma-stuti-maheshwara-tantre',
                component: ComponentCreator('/brahma-sri-brahma-stuti-maheshwara-tantre', 'b0c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/brahma-sri-brahma-stuti-panchakam',
                component: ComponentCreator('/brahma-sri-brahma-stuti-panchakam', 'da1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/brahma-sri-brahma-stuti-vayu-purane-vyasa-krutam',
                component: ComponentCreator('/brahma-sri-brahma-stuti-vayu-purane-vyasa-krutam', 'ca5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/brahma-vanaspati-suktam',
                component: ComponentCreator('/brahma-vanaspati-suktam', 'e74'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/category/अभंग-संग्रह',
                component: ComponentCreator('/category/अभंग-संग्रह', '039'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/category/अयोध्यकाण्ड',
                component: ComponentCreator('/category/अयोध्यकाण्ड', '12f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/category/अरण्यकाण्ड',
                component: ComponentCreator('/category/अरण्यकाण्ड', 'b29'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/category/अष्टक-संग्रह',
                component: ComponentCreator('/category/अष्टक-संग्रह', '211'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/category/आरती-संग्रह',
                component: ComponentCreator('/category/आरती-संग्रह', 'a70'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/category/ऑडियो-भजन',
                component: ComponentCreator('/category/ऑडियो-भजन', '030'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/category/कथा-संग्रह',
                component: ComponentCreator('/category/कथा-संग्रह', 'd9f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/category/कवचम्',
                component: ComponentCreator('/category/कवचम्', '861'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/category/किष्किन्धकाण्ड',
                component: ComponentCreator('/category/किष्किन्धकाण्ड', '776'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/category/चालीसा-संग्रह',
                component: ComponentCreator('/category/चालीसा-संग्रह', 'a21'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/category/जेष्ठा-गौरी-महालक्ष्मी-',
                component: ComponentCreator('/category/जेष्ठा-गौरी-महालक्ष्मी-', '1e9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/category/तुलसी-विवाह',
                component: ComponentCreator('/category/तुलसी-विवाह', 'e4d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/category/नामावली',
                component: ComponentCreator('/category/नामावली', '342'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/category/पाळणा-संग्रह',
                component: ComponentCreator('/category/पाळणा-संग्रह', '53f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/category/पितृपक्ष',
                component: ComponentCreator('/category/पितृपक्ष', 'e08'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/category/पूजा-व्रत',
                component: ComponentCreator('/category/पूजा-व्रत', 'ccf'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/category/पोथी',
                component: ComponentCreator('/category/पोथी', 'e0e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/category/बालकाण्ड',
                component: ComponentCreator('/category/बालकाण्ड', 'bff'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/category/मंगलाष्टका',
                component: ComponentCreator('/category/मंगलाष्टका', '780'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/category/मंत्र',
                component: ComponentCreator('/category/मंत्र', '164'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/category/मुंज',
                component: ComponentCreator('/category/मुंज', '44a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/category/युद्धकाण्ड',
                component: ComponentCreator('/category/युद्धकाण्ड', '7df'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/category/वाल्मीकि-रामायण',
                component: ComponentCreator('/category/वाल्मीकि-रामायण', 'dba'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/category/विवाह',
                component: ComponentCreator('/category/विवाह', 'c71'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/category/शास्त्रार्थ',
                component: ComponentCreator('/category/शास्त्रार्थ', '0f5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/category/शिवलीलामृत',
                component: ComponentCreator('/category/शिवलीलामृत', 'bba'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/category/श्री-दुर्गा-सप्तशती-संस्कृत',
                component: ComponentCreator('/category/श्री-दुर्गा-सप्तशती-संस्कृत', '964'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/category/श्री-नवनाथ-भक्तिसार',
                component: ComponentCreator('/category/श्री-नवनाथ-भक्तिसार', 'e6d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/category/श्री-सत्यनारायण-कथा',
                component: ComponentCreator('/category/श्री-सत्यनारायण-कथा', 'e4d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/category/श्री-स्वामी-चरित्र-सारामृत',
                component: ComponentCreator('/category/श्री-स्वामी-चरित्र-सारामृत', '3a5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/category/सुन्दरकाण्ड',
                component: ComponentCreator('/category/सुन्दरकाण्ड', 'cee'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/category/सूक्त-संग्रह',
                component: ComponentCreator('/category/सूक्त-संग्रह', 'f92'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/category/स्तोत्र--श्लोक-संग्रह',
                component: ComponentCreator('/category/स्तोत्र--श्लोक-संग्रह', 'f10'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/chakrapani',
                component: ComponentCreator('/chakrapani', '0a3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/chandra',
                component: ComponentCreator('/chandra', '9e4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/chandrabhagechya-tiri',
                component: ComponentCreator('/chandrabhagechya-tiri', 'c8d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/chhatrapati-shivaji-maharaj-palana',
                component: ComponentCreator('/chhatrapati-shivaji-maharaj-palana', 'cc0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/counter',
                component: ComponentCreator('/counter', 'ae8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dakshinamurthy-dakshinamurthy-varnamala-stotram-in-hindi',
                component: ComponentCreator('/dakshinamurthy-dakshinamurthy-varnamala-stotram-in-hindi', '4e6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dakshinamurthy-sri-dakshinamurthy-ashtakam-3-narasimha-bharati-krutam',
                component: ComponentCreator('/dakshinamurthy-sri-dakshinamurthy-ashtakam-3-narasimha-bharati-krutam', 'f21'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dakshinamurthy-sri-dakshinamurthy-ashtakam-4-vrushabha-deva-krutam',
                component: ComponentCreator('/dakshinamurthy-sri-dakshinamurthy-ashtakam-4-vrushabha-deva-krutam', '349'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dakshinamurthy-sri-dakshinamurthy-ashtottara-shatanama-stotram',
                component: ComponentCreator('/dakshinamurthy-sri-dakshinamurthy-ashtottara-shatanama-stotram', 'e80'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dakshinamurthy-sri-dakshinamurthy-bhujanga-prayata-stuti',
                component: ComponentCreator('/dakshinamurthy-sri-dakshinamurthy-bhujanga-prayata-stuti', 'a4a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dakshinamurthy-sri-dakshinamurthy-dandakam',
                component: ComponentCreator('/dakshinamurthy-sri-dakshinamurthy-dandakam', '7f2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dakshinamurthy-sri-dakshinamurthy-dashakam',
                component: ComponentCreator('/dakshinamurthy-sri-dakshinamurthy-dashakam', 'eb7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dakshinamurthy-sri-dakshinamurthy-hrudayam',
                component: ComponentCreator('/dakshinamurthy-sri-dakshinamurthy-hrudayam', '3e4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dakshinamurthy-sri-dakshinamurthy-kavacham-rudrayamala',
                component: ComponentCreator('/dakshinamurthy-sri-dakshinamurthy-kavacham-rudrayamala', '45e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dakshinamurthy-sri-dakshinamurthy-kavacham-trailokya-sammohanam',
                component: ComponentCreator('/dakshinamurthy-sri-dakshinamurthy-kavacham-trailokya-sammohanam', '150'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dakshinamurthy-sri-dakshinamurthy-manasika-puja-stotram',
                component: ComponentCreator('/dakshinamurthy-sri-dakshinamurthy-manasika-puja-stotram', 'b1b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dakshinamurthy-sri-dakshinamurthy-mantra-kavacham',
                component: ComponentCreator('/dakshinamurthy-sri-dakshinamurthy-mantra-kavacham', '020'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dakshinamurthy-sri-dakshinamurthy-mantrarna-ashtottara-shatanama-stotram',
                component: ComponentCreator('/dakshinamurthy-sri-dakshinamurthy-mantrarna-ashtottara-shatanama-stotram', '0e7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dakshinamurthy-sri-dakshinamurthy-manu-suvarnamala-stotram',
                component: ComponentCreator('/dakshinamurthy-sri-dakshinamurthy-manu-suvarnamala-stotram', 'd1f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dakshinamurthy-sri-dakshinamurthy-nakshatramala-stotram',
                component: ComponentCreator('/dakshinamurthy-sri-dakshinamurthy-nakshatramala-stotram', '2a6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dakshinamurthy-sri-dakshinamurthy-navamani-mala-stotram',
                component: ComponentCreator('/dakshinamurthy-sri-dakshinamurthy-navamani-mala-stotram', '143'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dakshinamurthy-sri-dakshinamurthy-navaratna-mala-stotram',
                component: ComponentCreator('/dakshinamurthy-sri-dakshinamurthy-navaratna-mala-stotram', '028'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dakshinamurthy-sri-dakshinamurthy-panjaram',
                component: ComponentCreator('/dakshinamurthy-sri-dakshinamurthy-panjaram', 'cc1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dakshinamurthy-sri-dakshinamurthy-sahasranama-stotram',
                component: ComponentCreator('/dakshinamurthy-sri-dakshinamurthy-sahasranama-stotram', 'f66'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dakshinamurthy-sri-dakshinamurthy-sahasranama-stotram-2',
                component: ComponentCreator('/dakshinamurthy-sri-dakshinamurthy-sahasranama-stotram-2', '825'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dakshinamurthy-sri-dakshinamurthy-shatkam',
                component: ComponentCreator('/dakshinamurthy-sri-dakshinamurthy-shatkam', '7ce'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dakshinamurthy-sri-dakshinamurthy-shodasopachara-pooja',
                component: ComponentCreator('/dakshinamurthy-sri-dakshinamurthy-shodasopachara-pooja', 'ba6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dakshinamurthy-sri-dakshinamurthy-stotram-1',
                component: ComponentCreator('/dakshinamurthy-sri-dakshinamurthy-stotram-1', '183'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dakshinamurthy-sri-dakshinamurthy-stotram-2',
                component: ComponentCreator('/dakshinamurthy-sri-dakshinamurthy-stotram-2', '823'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dakshinamurthy-sri-dakshinamurthy-stotram-3-jaya-ghosha',
                component: ComponentCreator('/dakshinamurthy-sri-dakshinamurthy-stotram-3-jaya-ghosha', 'd47'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dakshinamurthy-sri-dakshinamurthy-stotram-5',
                component: ComponentCreator('/dakshinamurthy-sri-dakshinamurthy-stotram-5', 'eef'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dakshinamurthy-sri-dakshinamurthy-stuti',
                component: ComponentCreator('/dakshinamurthy-sri-dakshinamurthy-stuti', '2ab'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dakshinamurthy-sri-dakshinasya-pancharatna-stotram',
                component: ComponentCreator('/dakshinamurthy-sri-dakshinasya-pancharatna-stotram', 'e26'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dakshinamurthy-sri-gurumurthy-stotram',
                component: ComponentCreator('/dakshinamurthy-sri-gurumurthy-stotram', '673'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-jaganmangala-kali-kavacham',
                component: ComponentCreator('/dasa-mahavidya-jaganmangala-kali-kavacham', 'd97'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-kakaradi-kali-sahasranama-stotram',
                component: ComponentCreator('/dasa-mahavidya-kakaradi-kali-sahasranama-stotram', '155'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-maha-tripura-sundari-hrudayam',
                component: ComponentCreator('/dasa-mahavidya-maha-tripura-sundari-hrudayam', 'a1d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-maha-tripura-sundari-shatkam',
                component: ComponentCreator('/dasa-mahavidya-maha-tripura-sundari-shatkam', 'b9b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-prachanda-chandika-stavaraja',
                component: ComponentCreator('/dasa-mahavidya-prachanda-chandika-stavaraja', 'ff3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-adya-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-adya-stotram', '5f7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-bagalamukhi-ashtottara-shatanama-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-bagalamukhi-ashtottara-shatanama-stotram', '006'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-bagalamukhi-ashtottara-shatanama-stotram-1-rudrayamale',
                component: ComponentCreator('/dasa-mahavidya-sri-bagalamukhi-ashtottara-shatanama-stotram-1-rudrayamale', 'fd7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-bagalamukhi-dasanamatmaka-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-bagalamukhi-dasanamatmaka-stotram', '24c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-bagalamukhi-digbandhana-raksha-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-bagalamukhi-digbandhana-raksha-stotram', 'd5c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-bagalamukhi-hrudayam',
                component: ComponentCreator('/dasa-mahavidya-sri-bagalamukhi-hrudayam', '20f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-bagalamukhi-kavacham-1-rudrayamale',
                component: ComponentCreator('/dasa-mahavidya-sri-bagalamukhi-kavacham-1-rudrayamale', '2c7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-bagalamukhi-kavacham-2-vairinashakaram',
                component: ComponentCreator('/dasa-mahavidya-sri-bagalamukhi-kavacham-2-vairinashakaram', '78a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-bagalamukhi-kavacham-3',
                component: ComponentCreator('/dasa-mahavidya-sri-bagalamukhi-kavacham-3', '95d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-bagalamukhi-kavacham-4-trailokya-vijayam',
                component: ComponentCreator('/dasa-mahavidya-sri-bagalamukhi-kavacham-4-trailokya-vijayam', '972'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-bagalamukhi-kavacham-5-shatru-vinashakaram',
                component: ComponentCreator('/dasa-mahavidya-sri-bagalamukhi-kavacham-5-shatru-vinashakaram', '844'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-bagalamukhi-keelaka-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-bagalamukhi-keelaka-stotram', '44d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-bagalamukhi-khadga-mala-mantra',
                component: ComponentCreator('/dasa-mahavidya-sri-bagalamukhi-khadga-mala-mantra', '740'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-bagalamukhi-mala-mantra',
                component: ComponentCreator('/dasa-mahavidya-sri-bagalamukhi-mala-mantra', '787'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-bagalamukhi-panjara-nyasa-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-bagalamukhi-panjara-nyasa-stotram', '140'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-bagalamukhi-panjara-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-bagalamukhi-panjara-stotram', 'bd6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-bagalamukhi-sahasranama-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-bagalamukhi-sahasranama-stotram', '910'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-bagalamukhi-shodasopachara-puja',
                component: ComponentCreator('/dasa-mahavidya-sri-bagalamukhi-shodasopachara-puja', 'a01'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-bagalamukhi-stavaraja',
                component: ComponentCreator('/dasa-mahavidya-sri-bagalamukhi-stavaraja', '425'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-bagalamukhi-stotram-1',
                component: ComponentCreator('/dasa-mahavidya-sri-bagalamukhi-stotram-1', '95d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-bagalamukhi-stotram-2',
                component: ComponentCreator('/dasa-mahavidya-sri-bagalamukhi-stotram-2', '9f9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-bagalamukhi-suktam',
                component: ComponentCreator('/dasa-mahavidya-sri-bagalamukhi-suktam', '18e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-bagalamukhi-varna-kavacham',
                component: ComponentCreator('/dasa-mahavidya-sri-bagalamukhi-varna-kavacham', 'd54'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-bhadrakali-ashtakam-1',
                component: ComponentCreator('/dasa-mahavidya-sri-bhadrakali-ashtakam-1', '906'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-bhadrakali-ashtakam-2',
                component: ComponentCreator('/dasa-mahavidya-sri-bhadrakali-ashtakam-2', 'd39'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-bhadrakali-ashtottara-shatanama-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-bhadrakali-ashtottara-shatanama-stotram', 'd6b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-bhadrakali-kavacham-1',
                component: ComponentCreator('/dasa-mahavidya-sri-bhadrakali-kavacham-1', 'fd1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-bhadrakali-kavacham-2-jaganmangalam',
                component: ComponentCreator('/dasa-mahavidya-sri-bhadrakali-kavacham-2-jaganmangalam', '21f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-bhadrakali-stuti',
                component: ComponentCreator('/dasa-mahavidya-sri-bhadrakali-stuti', '8b7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-bhairavi-kavacham-trailokyavijayam',
                component: ComponentCreator('/dasa-mahavidya-sri-bhairavi-kavacham-trailokyavijayam', 'abe'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-bhuvaneshwari-ashtottara-shatanama-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-bhuvaneshwari-ashtottara-shatanama-stotram', '167'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-bhuvaneshwari-hrudayam',
                component: ComponentCreator('/dasa-mahavidya-sri-bhuvaneshwari-hrudayam', 'ef3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-bhuvaneshwari-kavacham-trailokya-mangalam',
                component: ComponentCreator('/dasa-mahavidya-sri-bhuvaneshwari-kavacham-trailokya-mangalam', '80b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-bhuvaneshwari-panjara-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-bhuvaneshwari-panjara-stotram', '580'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-bhuvaneshwari-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-bhuvaneshwari-stotram', '0c7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-chinnamasta-ashtottara-shatanama-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-chinnamasta-ashtottara-shatanama-stotram', '93a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-chinnamasta-kavacham',
                component: ComponentCreator('/dasa-mahavidya-sri-chinnamasta-kavacham', 'eb1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-chinnamastha-devi-hridayam',
                component: ComponentCreator('/dasa-mahavidya-sri-chinnamastha-devi-hridayam', '786'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-chinnamastha-devi-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-chinnamastha-devi-stotram', 'c29'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-dakshina-kali-hrudayam-2',
                component: ComponentCreator('/dasa-mahavidya-sri-dakshina-kali-hrudayam-2', '3f0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-dakshina-kali-kavacham-1',
                component: ComponentCreator('/dasa-mahavidya-sri-dakshina-kali-kavacham-1', '6f8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-dakshina-kali-kavacham-2',
                component: ComponentCreator('/dasa-mahavidya-sri-dakshina-kali-kavacham-2', '0b3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-dakshina-kali-khadgamala-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-dakshina-kali-khadgamala-stotram', '134'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-dakshina-kali-trishati-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-dakshina-kali-trishati-stotram', '2d1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-dhumavathi-hrudayam',
                component: ComponentCreator('/dasa-mahavidya-sri-dhumavathi-hrudayam', '444'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-dhumavathi-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-dhumavathi-stotram', 'c4f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-dhumavati-ashtottara-shatanama-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-dhumavati-ashtottara-shatanama-stotram', 'c1c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-dhumavati-kavacham',
                component: ComponentCreator('/dasa-mahavidya-sri-dhumavati-kavacham', 'bfc'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-guhya-kali-sudha-dhara-stava',
                component: ComponentCreator('/dasa-mahavidya-sri-guhya-kali-sudha-dhara-stava', '6ba'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-guhya-kali-vajra-kavacham',
                component: ComponentCreator('/dasa-mahavidya-sri-guhya-kali-vajra-kavacham', '97d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-kali-aparadha-kshamapana-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-kali-aparadha-kshamapana-stotram', '8cf'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-kali-ashtottara-shatanama-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-kali-ashtottara-shatanama-stotram', '128'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-kali-ekakshari-beeja-mantra-chintamani',
                component: ComponentCreator('/dasa-mahavidya-sri-kali-ekakshari-beeja-mantra-chintamani', '219'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-kali-hrudayam',
                component: ComponentCreator('/dasa-mahavidya-sri-kali-hrudayam', '993'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-kali-karpura-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-kali-karpura-stotram', '751'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-kali-kavacham-trailokya-vijayam',
                component: ComponentCreator('/dasa-mahavidya-sri-kali-kavacham-trailokya-vijayam', '07f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-kali-krama-stava',
                component: ComponentCreator('/dasa-mahavidya-sri-kali-krama-stava', 'af4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-kali-pratah-smarana-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-kali-pratah-smarana-stotram', '439'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-kali-sahasrakshari',
                component: ComponentCreator('/dasa-mahavidya-sri-kali-sahasrakshari', 'fb2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-kali-shanti-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-kali-shanti-stotram', 'b88'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-kali-stavanam-shakini-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-kali-stavanam-shakini-stotram', '22b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-kali-stuti-brahma-krutam',
                component: ComponentCreator('/dasa-mahavidya-sri-kali-stuti-brahma-krutam', '1b3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-kali-tandava-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-kali-tandava-stotram', '09a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-kalika-argala-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-kalika-argala-stotram', '97d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-kalika-kavacham-vairinashakam',
                component: ComponentCreator('/dasa-mahavidya-sri-kalika-kavacham-vairinashakam', '17d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-kalika-keelaka-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-kalika-keelaka-stotram', '531'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-kalika-sahasranama-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-kalika-sahasranama-stotram', 'ca4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-kalika-shatanama-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-kalika-shatanama-stotram', '1ca'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-kalika-stotram-1',
                component: ComponentCreator('/dasa-mahavidya-sri-kalika-stotram-1', 'bfe'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-kalika-stotram-2',
                component: ComponentCreator('/dasa-mahavidya-sri-kalika-stotram-2', 'b16'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-kalika-swaroopa-stuti',
                component: ComponentCreator('/dasa-mahavidya-sri-kalika-swaroopa-stuti', 'fdc'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-kamakala-kali-bhujanga-prayata-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-kamakala-kali-bhujanga-prayata-stotram', '63c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-kamakala-kali-kavacham-trailokyamohanam',
                component: ComponentCreator('/dasa-mahavidya-sri-kamakala-kali-kavacham-trailokyamohanam', '334'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-kamakala-kali-sahasranama-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-kamakala-kali-sahasranama-stotram', '613'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-kamakala-kali-sanjeevana-gadya-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-kamakala-kali-sanjeevana-gadya-stotram', '04c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-kamala-ashtottara-shatanama-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-kamala-ashtottara-shatanama-stotram', '740'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-kamala-kavacham',
                component: ComponentCreator('/dasa-mahavidya-sri-kamala-kavacham', 'bb3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-kamala-sahasranama-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-kamala-sahasranama-stotram', '6fe'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-kamala-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-kamala-stotram', '476'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-kamala-stotram-2',
                component: ComponentCreator('/dasa-mahavidya-sri-kamala-stotram-2', 'ea0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-kamalambika-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-kamalambika-stotram', '9d2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-maha-kali-shatanama-stotram-brihan-nila-tantram',
                component: ComponentCreator('/dasa-mahavidya-sri-maha-kali-shatanama-stotram-brihan-nila-tantram', '39c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-maha-kali-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-maha-kali-stotram', '681'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-matangi-ashtottara-shatanama-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-matangi-ashtottara-shatanama-stotram', '79d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-matangi-kavacham',
                component: ComponentCreator('/dasa-mahavidya-sri-matangi-kavacham', '3d5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-matangi-sahasranama-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-matangi-sahasranama-stotram', '70d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-matangini-kavacham-trailokya-mangala-kavacham',
                component: ComponentCreator('/dasa-mahavidya-sri-matangini-kavacham-trailokya-mangala-kavacham', 'b04'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-mathangi-hrudayam',
                component: ComponentCreator('/dasa-mahavidya-sri-mathangi-hrudayam', '09d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-mathangi-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-mathangi-stotram', 'd38'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-neela-saraswati-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-neela-saraswati-stotram', '9d9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-shodashi-ashtottara-shatanama-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-shodashi-ashtottara-shatanama-stotram', '933'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-tara-ashtottara-shatanama-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-tara-ashtottara-shatanama-stotram', '907'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-tara-kavacham',
                component: ComponentCreator('/dasa-mahavidya-sri-tara-kavacham', 'afd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-tara-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-tara-stotram', '752'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-taramba-tara-hrudayam',
                component: ComponentCreator('/dasa-mahavidya-sri-taramba-tara-hrudayam', '05c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-tripura-bhairavi-ashtottara-shatanama-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-tripura-bhairavi-ashtottara-shatanama-stotram', 'bde'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-tripura-bhairavi-hrudayam',
                component: ComponentCreator('/dasa-mahavidya-sri-tripura-bhairavi-hrudayam', '840'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-tripura-bhairavi-kavacham',
                component: ComponentCreator('/dasa-mahavidya-sri-tripura-bhairavi-kavacham', '3cf'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-tripura-bhairavi-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-tripura-bhairavi-stotram', '789'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-sri-tripura-sundari-stotram',
                component: ComponentCreator('/dasa-mahavidya-sri-tripura-sundari-stotram', '3cd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-tripura-sundari-pancharatna-stotram',
                component: ComponentCreator('/dasa-mahavidya-tripura-sundari-pancharatna-stotram', '386'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-tripurasundari-ashtakam',
                component: ComponentCreator('/dasa-mahavidya-tripurasundari-ashtakam', '18c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-tripurasundari-manasa-puja-stotram',
                component: ComponentCreator('/dasa-mahavidya-tripurasundari-manasa-puja-stotram', '5f5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dasa-mahavidya-tripurasundari-veda-pada-stava',
                component: ComponentCreator('/dasa-mahavidya-tripurasundari-veda-pada-stava', '693'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dashavtarachi',
                component: ComponentCreator('/dashavtarachi', '86e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/datt',
                component: ComponentCreator('/datt', '229'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/datt-palana',
                component: ComponentCreator('/datt-palana', '367'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/datta-bavanni-stotra',
                component: ComponentCreator('/datta-bavanni-stotra', '179'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/datta-mala-stotra',
                component: ComponentCreator('/datta-mala-stotra', 'b2d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dattatrey-stuti',
                component: ComponentCreator('/dattatrey-stuti', 'b3b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi',
                component: ComponentCreator('/devi', '771'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-abhirami-stotram',
                component: ComponentCreator('/devi-abhirami-stotram', '50f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-akhilandeshwari-stotram',
                component: ComponentCreator('/devi-akhilandeshwari-stotram', '9d5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-anandalahari',
                component: ComponentCreator('/devi-anandalahari', '99d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-annapurna-stotram',
                component: ComponentCreator('/devi-annapurna-stotram', '6d0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-ashtadasa-sakthi-peeta-stotram',
                component: ComponentCreator('/devi-ashtadasa-sakthi-peeta-stotram', 'b7b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-bhavani-ashtakam',
                component: ComponentCreator('/devi-bhavani-ashtakam', '495'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-bhavani-bhujangaprayata-stotram',
                component: ComponentCreator('/devi-bhavani-bhujangaprayata-stotram', '2e2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-bhramaramba-ashtakam',
                component: ComponentCreator('/devi-bhramaramba-ashtakam', '3dc'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-chatushashti-64-yogini-nama-stotram',
                component: ComponentCreator('/devi-chatushashti-64-yogini-nama-stotram', 'c55'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-chatushashti-64-yogini-nama-stotram-2',
                component: ComponentCreator('/devi-chatushashti-64-yogini-nama-stotram-2', 'b3d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-devi-aparadha-kshamapana-stotram',
                component: ComponentCreator('/devi-devi-aparadha-kshamapana-stotram', 'dcc'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-devi-bhujanga-stotram',
                component: ComponentCreator('/devi-devi-bhujanga-stotram', '987'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-devi-chatushasti-upachara-puja-stotram',
                component: ComponentCreator('/devi-devi-chatushasti-upachara-puja-stotram', 'daa'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-devi-pranava-sloki-stuti',
                component: ComponentCreator('/devi-devi-pranava-sloki-stuti', '39a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-devi-shatkam',
                component: ComponentCreator('/devi-devi-shatkam', 'c4b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-garbha-rakshambika-stotram',
                component: ComponentCreator('/devi-garbha-rakshambika-stotram', '931'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-gauri-dashakam',
                component: ComponentCreator('/devi-gauri-dashakam', '131'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-goda-stuti',
                component: ComponentCreator('/devi-goda-stuti', '97f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-kalyana-vrishti-stava',
                component: ComponentCreator('/devi-kalyana-vrishti-stava', '73c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-khadagmala',
                component: ComponentCreator('/devi-khadagmala', '716'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-kiraata-varahi-stotram',
                component: ComponentCreator('/devi-kiraata-varahi-stotram', '6bf'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-matrika-varna-stotram',
                component: ComponentCreator('/devi-matrika-varna-stotram', '631'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-meenakshi-pancharatnam',
                component: ComponentCreator('/devi-meenakshi-pancharatnam', 'f57'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-meenakshi-stotram',
                component: ComponentCreator('/devi-meenakshi-stotram', '9c9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-panchastavi-1-laghu-stava',
                component: ComponentCreator('/devi-panchastavi-1-laghu-stava', 'fcc'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-panchastavi-2-charcha-stava',
                component: ComponentCreator('/devi-panchastavi-2-charcha-stava', '4da'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-panchastavi-3-ghata-stava',
                component: ComponentCreator('/devi-panchastavi-3-ghata-stava', '6a6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-panchastavi-4-amba-stava',
                component: ComponentCreator('/devi-panchastavi-4-amba-stava', '5d7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-panchastavi-5-sakalajanani-stava',
                component: ComponentCreator('/devi-panchastavi-5-sakalajanani-stava', '386'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-parashurama-kruta-kali-stotram',
                component: ComponentCreator('/devi-parashurama-kruta-kali-stotram', 'a51'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-rajarajeshwari-ashtakam',
                component: ComponentCreator('/devi-rajarajeshwari-ashtakam', '7aa'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sankata-nama-ashtakam',
                component: ComponentCreator('/devi-sankata-nama-ashtakam', '167'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-saptha-matrika-stotram',
                component: ComponentCreator('/devi-saptha-matrika-stotram', '922'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-saubhagya-ashtottara-shatanama-stotram',
                component: ComponentCreator('/devi-saubhagya-ashtottara-shatanama-stotram', '831'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-shreyaskari-stotram',
                component: ComponentCreator('/devi-shreyaskari-stotram', '51d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-shyamala-dandakam',
                component: ComponentCreator('/devi-shyamala-dandakam', '501'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-shyamala-stotram',
                component: ComponentCreator('/devi-shyamala-stotram', '0d7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-adi-varahi-stotram',
                component: ComponentCreator('/devi-sri-adi-varahi-stotram', 'd3b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-amba-bhujanga-pancharatna-stotram',
                component: ComponentCreator('/devi-sri-amba-bhujanga-pancharatna-stotram', 'bcb'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-amba-pancharatnam',
                component: ComponentCreator('/devi-sri-amba-pancharatnam', '05a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-annapurna-ashtottara-satanama-stotram',
                component: ComponentCreator('/devi-sri-annapurna-ashtottara-satanama-stotram', '4fd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-annapurna-mantra-stava',
                component: ComponentCreator('/devi-sri-annapurna-mantra-stava', 'b3e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-bala-ashtottara-satanama-stotram',
                component: ComponentCreator('/devi-sri-bala-ashtottara-satanama-stotram', 'aa8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-bala-hrudayam',
                component: ComponentCreator('/devi-sri-bala-hrudayam', 'c05'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-bala-kavacham',
                component: ComponentCreator('/devi-sri-bala-kavacham', '7ad'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-bala-kavacham-2-rudrayamale',
                component: ComponentCreator('/devi-sri-bala-kavacham-2-rudrayamale', 'eb6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-bala-khadgamala-stotram',
                component: ComponentCreator('/devi-sri-bala-khadgamala-stotram', '477'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-bala-makaranda-stava',
                component: ComponentCreator('/devi-sri-bala-makaranda-stava', '303'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-bala-manasa-puja-stotram',
                component: ComponentCreator('/devi-sri-bala-manasa-puja-stotram', '6c1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-bala-mantra-siddhi-stava',
                component: ComponentCreator('/devi-sri-bala-mantra-siddhi-stava', 'c38'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-bala-mantragarbha-ashtakam',
                component: ComponentCreator('/devi-sri-bala-mantragarbha-ashtakam', 'd09'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-bala-pancharatna-stotram',
                component: ComponentCreator('/devi-sri-bala-pancharatna-stotram', '120'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-bala-stavaraja',
                component: ComponentCreator('/devi-sri-bala-stavaraja', '12d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-bala-stotram',
                component: ComponentCreator('/devi-sri-bala-stotram', '927'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-bala-stotram-2',
                component: ComponentCreator('/devi-sri-bala-stotram-2', 'd5a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-bala-tripurasundari-raksha-stotram',
                component: ComponentCreator('/devi-sri-bala-tripurasundari-raksha-stotram', 'c67'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-bala-tripurasundari-triyakshari-mantra',
                component: ComponentCreator('/devi-sri-bala-tripurasundari-triyakshari-mantra', '0ab'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-bala-trishati-stotram',
                component: ComponentCreator('/devi-sri-bala-trishati-stotram', '5ea'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-bala-vanchadatri-stotram',
                component: ComponentCreator('/devi-sri-bala-vanchadatri-stotram', '75c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-bala-vimsathi-stava',
                component: ComponentCreator('/devi-sri-bala-vimsathi-stava', '41c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-balambika-ashtakam',
                component: ComponentCreator('/devi-sri-balambika-ashtakam', '245'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-bhramarambika-ashtakam-sri-kantarpita',
                component: ComponentCreator('/devi-sri-bhramarambika-ashtakam-sri-kantarpita', '404'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-buddhi-devi-ashtottara-shatanama-stotram',
                component: ComponentCreator('/devi-sri-buddhi-devi-ashtottara-shatanama-stotram', '68f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-dakshayani-stotram',
                component: ComponentCreator('/devi-sri-dakshayani-stotram', '2d6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-devi-khadgamala-namavali',
                component: ComponentCreator('/devi-sri-devi-khadgamala-namavali', '41a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-gauri-navaratnamalika-stava',
                component: ComponentCreator('/devi-sri-gauri-navaratnamalika-stava', 'b46'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-gauri-saptashloki-stuti',
                component: ComponentCreator('/devi-sri-gauri-saptashloki-stuti', 'c46'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-gnana-prasunambika-stotram',
                component: ComponentCreator('/devi-sri-gnana-prasunambika-stotram', '833'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-goda-devi-ashtottara-shatanama-stotram',
                component: ComponentCreator('/devi-sri-goda-devi-ashtottara-shatanama-stotram', 'a18'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-jagaddhatri-stotram',
                component: ComponentCreator('/devi-sri-jagaddhatri-stotram', '936'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-jogulamba-ashtakam',
                component: ComponentCreator('/devi-sri-jogulamba-ashtakam', 'f2b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-jwalamukhi-ashtakam',
                component: ComponentCreator('/devi-sri-jwalamukhi-ashtakam', '03f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-jwalamukhi-stotram-1',
                component: ComponentCreator('/devi-sri-jwalamukhi-stotram-1', 'd2c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-jwalamukhi-stotram-2',
                component: ComponentCreator('/devi-sri-jwalamukhi-stotram-2', '84e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-kamakhya-stotram',
                component: ComponentCreator('/devi-sri-kamakhya-stotram', '177'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-kamakshi-stotram',
                component: ComponentCreator('/devi-sri-kamakshi-stotram', '018'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-kubjika-varnana-stotram',
                component: ComponentCreator('/devi-sri-kubjika-varnana-stotram', 'd25'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-manasa-devi-mula-mantram',
                component: ComponentCreator('/devi-sri-manasa-devi-mula-mantram', '1b8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-mangala-gauri-stotram',
                component: ComponentCreator('/devi-sri-mangala-gauri-stotram', '9cb'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-mukambika-stotram',
                component: ComponentCreator('/devi-sri-mukambika-stotram', '162'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-renuka-ashtottara-shatanama-stotram',
                component: ComponentCreator('/devi-sri-renuka-ashtottara-shatanama-stotram', '61a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-renuka-ashtottara-shatanamavali',
                component: ComponentCreator('/devi-sri-renuka-ashtottara-shatanamavali', '874'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-renuka-hrudayam',
                component: ComponentCreator('/devi-sri-renuka-hrudayam', 'eaf'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-renuka-kavacham',
                component: ComponentCreator('/devi-sri-renuka-kavacham', '76e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-renuka-stotram-parashurama-kritam',
                component: ComponentCreator('/devi-sri-renuka-stotram-parashurama-kritam', 'c47'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-sarvamangala-stotram',
                component: ComponentCreator('/devi-sri-sarvamangala-stotram', 'ae3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-seethalashtakam',
                component: ComponentCreator('/devi-sri-seethalashtakam', '94b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-shashti-devi-stotram',
                component: ComponentCreator('/devi-sri-shashti-devi-stotram', '1cc'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-shyamala-ashtottara-shatanama-stotram',
                component: ComponentCreator('/devi-sri-shyamala-ashtottara-shatanama-stotram', '28f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-shyamala-ashtottara-shatanama-stotram-2',
                component: ComponentCreator('/devi-sri-shyamala-ashtottara-shatanama-stotram-2', '332'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-shyamala-kavacham',
                component: ComponentCreator('/devi-sri-shyamala-kavacham', '08a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-shyamala-panchasathsvara-varna-maalikaa-stotram',
                component: ComponentCreator('/devi-sri-shyamala-panchasathsvara-varna-maalikaa-stotram', '01c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-shyamala-shodasa-namavali',
                component: ComponentCreator('/devi-sri-shyamala-shodasa-namavali', '1d1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-shyamala-shodashanama-stotram',
                component: ComponentCreator('/devi-sri-shyamala-shodashanama-stotram', '7c3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-siddhi-devi-ashtottara-shatanama-stotram',
                component: ComponentCreator('/devi-sri-siddhi-devi-ashtottara-shatanama-stotram', '591'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-tulja-bhavani-stotram',
                component: ComponentCreator('/devi-sri-tulja-bhavani-stotram', '514'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-uma-ashtottara-shatanama-stotram',
                component: ComponentCreator('/devi-sri-uma-ashtottara-shatanama-stotram', '722'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-varahamukhi-stava',
                component: ComponentCreator('/devi-sri-varahamukhi-stava', 'd37'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-varahi-anugraha-ashtakam',
                component: ComponentCreator('/devi-sri-varahi-anugraha-ashtakam', 'af4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-varahi-ashtottara-shatanama-stotram',
                component: ComponentCreator('/devi-sri-varahi-ashtottara-shatanama-stotram', '992'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-varahi-devi-stavam',
                component: ComponentCreator('/devi-sri-varahi-devi-stavam', 'c7d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-varahi-dwadasa-nama-stotram',
                component: ComponentCreator('/devi-sri-varahi-dwadasa-nama-stotram', '2c9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-varahi-dwadasa-namavali',
                component: ComponentCreator('/devi-sri-varahi-dwadasa-namavali', '2c3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-varahi-kavacham',
                component: ComponentCreator('/devi-sri-varahi-kavacham', '2f0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-varahi-nigraha-ashtakam',
                component: ComponentCreator('/devi-sri-varahi-nigraha-ashtakam', '2e9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-varahi-sahasranama-stotram',
                component: ComponentCreator('/devi-sri-varahi-sahasranama-stotram', '933'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-varahi-vartali-moola-mantram',
                component: ComponentCreator('/devi-sri-varahi-vartali-moola-mantram', 'd6a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-vasavi-kanyaka-ashtakam',
                component: ComponentCreator('/devi-sri-vasavi-kanyaka-ashtakam', 'e6e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-vasya-varahi-stotram',
                component: ComponentCreator('/devi-sri-vasya-varahi-stotram', 'de1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-vindhyavasini-vindhyeshwari-stotram',
                component: ComponentCreator('/devi-sri-vindhyavasini-vindhyeshwari-stotram', 'da7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-visalakshi-stotram-vyasa-krutam',
                component: ComponentCreator('/devi-sri-visalakshi-stotram-vyasa-krutam', '615'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sri-yoga-meenakshi-stotram',
                component: ComponentCreator('/devi-sri-yoga-meenakshi-stotram', '571'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-subhagodaya-stuti-gaudapadacharya-virachitam',
                component: ComponentCreator('/devi-subhagodaya-stuti-gaudapadacharya-virachitam', '1a8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-sukta',
                component: ComponentCreator('/devi-sukta', '37b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-trailokya-vijaya-vidya-mantra',
                component: ComponentCreator('/devi-trailokya-vijaya-vidya-mantra', '452'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/devi-vasavi-stotram',
                component: ComponentCreator('/devi-vasavi-stotram', '43f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dhanvantari',
                component: ComponentCreator('/dhanvantari', '92d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dharitri-devanchi-kahani',
                component: ComponentCreator('/dharitri-devanchi-kahani', 'd1c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/divyachya-avsechi-kahani',
                component: ComponentCreator('/divyachya-avsechi-kahani', 'ac4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dnyaniyancha-raja',
                component: ComponentCreator('/dnyaniyancha-raja', '8f2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dudhachi-khulbhar-kahani',
                component: ComponentCreator('/dudhachi-khulbhar-kahani', 'c76'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-aapadunmoolana-sri-durga-stotram',
                component: ComponentCreator('/durga-aapadunmoolana-sri-durga-stotram', '3b5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-aparajitha-stotram',
                component: ComponentCreator('/durga-aparajitha-stotram', '870'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-argala-stotram',
                component: ComponentCreator('/durga-argala-stotram', '11b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-brahmanda-mohana-durga-kavacham',
                component: ComponentCreator('/durga-brahmanda-mohana-durga-kavacham', 'bf6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-dakaradi-sri-durga-sahasranama-stotram-in-devanagari',
                component: ComponentCreator('/durga-dakaradi-sri-durga-sahasranama-stotram-in-devanagari', '88b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-durga-dvatimshannamavali',
                component: ComponentCreator('/durga-durga-dvatimshannamavali', '840'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-durga-suktam',
                component: ComponentCreator('/durga-durga-suktam', '422'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-krishna-kruta-durga-stotram',
                component: ComponentCreator('/durga-krishna-kruta-durga-stotram', '6b9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-kumari-stotram-1',
                component: ComponentCreator('/durga-kumari-stotram-1', '602'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-mahadeva-kruta-durga-stotram',
                component: ComponentCreator('/durga-mahadeva-kruta-durga-stotram', '1e6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-narayani-stuti',
                component: ComponentCreator('/durga-narayani-stuti', '112'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-navadurga-stotram',
                component: ComponentCreator('/durga-navadurga-stotram', 'ef7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-parashurama-kruta-durga-stotram',
                component: ComponentCreator('/durga-parashurama-kruta-durga-stotram', 'db0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-saptasati-tantrokta-ratri-suktam',
                component: ComponentCreator('/durga-saptasati-tantrokta-ratri-suktam', '280'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-saptshati-path-adhyay-1',
                component: ComponentCreator('/durga-saptshati-path-adhyay-1', '829'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-saptshati-path-adhyay-10',
                component: ComponentCreator('/durga-saptshati-path-adhyay-10', '26d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-saptshati-path-adhyay-11',
                component: ComponentCreator('/durga-saptshati-path-adhyay-11', 'c6f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-saptshati-path-adhyay-12',
                component: ComponentCreator('/durga-saptshati-path-adhyay-12', '1f4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-saptshati-path-adhyay-13',
                component: ComponentCreator('/durga-saptshati-path-adhyay-13', '5d1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-saptshati-path-adhyay-2',
                component: ComponentCreator('/durga-saptshati-path-adhyay-2', 'a73'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-saptshati-path-adhyay-3',
                component: ComponentCreator('/durga-saptshati-path-adhyay-3', '596'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-saptshati-path-adhyay-4',
                component: ComponentCreator('/durga-saptshati-path-adhyay-4', '19c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-saptshati-path-adhyay-5',
                component: ComponentCreator('/durga-saptshati-path-adhyay-5', 'a41'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-saptshati-path-adhyay-6',
                component: ComponentCreator('/durga-saptshati-path-adhyay-6', '4df'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-saptshati-path-adhyay-7',
                component: ComponentCreator('/durga-saptshati-path-adhyay-7', 'a16'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-saptshati-path-adhyay-8',
                component: ComponentCreator('/durga-saptshati-path-adhyay-8', '8ff'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-saptshati-path-adhyay-9',
                component: ComponentCreator('/durga-saptshati-path-adhyay-9', 'af0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-siddha-kunjika-stotram',
                component: ComponentCreator('/durga-siddha-kunjika-stotram', '2e3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-sree-durga-ashtottara-satanama-stotram',
                component: ComponentCreator('/durga-sree-durga-ashtottara-satanama-stotram', '9d7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-sri-chamundeshwari-ashtottara-shatanama-stotram',
                component: ComponentCreator('/durga-sri-chamundeshwari-ashtottara-shatanama-stotram', '45d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-sri-chandika-stotram',
                component: ComponentCreator('/durga-sri-chandika-stotram', '5d5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-sri-deepa-durga-kavacham',
                component: ComponentCreator('/durga-sri-deepa-durga-kavacham', 'e68'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-sri-durga-apaduddharaka-stotram',
                component: ComponentCreator('/durga-sri-durga-apaduddharaka-stotram', 'a5e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-sri-durga-arya-stavam',
                component: ComponentCreator('/durga-sri-durga-arya-stavam', '2f0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-sri-durga-ashtakam',
                component: ComponentCreator('/durga-sri-durga-ashtakam', '9c4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-sri-durga-ashtottara-satanama-stotram-1',
                component: ComponentCreator('/durga-sri-durga-ashtottara-satanama-stotram-1', '871'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-sri-durga-chandrakala-stuti-in-devanagari',
                component: ComponentCreator('/durga-sri-durga-chandrakala-stuti-in-devanagari', '8af'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-sri-durga-devi-shodashopachara-puja',
                component: ComponentCreator('/durga-sri-durga-devi-shodashopachara-puja', 'c44'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-sri-durga-kavacham',
                component: ComponentCreator('/durga-sri-durga-kavacham', 'ac9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-sri-durga-manasa-puja-stotram',
                component: ComponentCreator('/durga-sri-durga-manasa-puja-stotram', '0ad'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-sri-durga-pancharatnam',
                component: ComponentCreator('/durga-sri-durga-pancharatnam', '7bf'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-sri-durga-parameshwari-stotram-by-sringeri-jagadguru',
                component: ComponentCreator('/durga-sri-durga-parameshwari-stotram-by-sringeri-jagadguru', 'd5a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-sri-durga-sahasranama-stotram',
                component: ComponentCreator('/durga-sri-durga-sahasranama-stotram', 'f7c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-sri-durga-shodasa-nama-stotram',
                component: ComponentCreator('/durga-sri-durga-shodasa-nama-stotram', '22d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-sri-durga-stotram',
                component: ComponentCreator('/durga-sri-durga-stotram', 'fc5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-sri-durga-stotram-2-shiva-rahasye',
                component: ComponentCreator('/durga-sri-durga-stotram-2-shiva-rahasye', 'e6c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-sri-durga-stotram-arjuna-krutam',
                component: ComponentCreator('/durga-sri-durga-stotram-arjuna-krutam', 'a59'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-sri-indrakshi-stotram',
                component: ComponentCreator('/durga-sri-indrakshi-stotram', '73c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-sri-mangala-chandika-stotram',
                component: ComponentCreator('/durga-sri-mangala-chandika-stotram', '612'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-sri-rudra-chandi-stotram',
                component: ComponentCreator('/durga-sri-rudra-chandi-stotram', 'c06'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durga-vamsa-vruddhikaram-vamsakhya-durga-kavacham',
                component: ComponentCreator('/durga-vamsa-vruddhikaram-vamsakhya-durga-kavacham', '4f6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/durgasaptshati',
                component: ComponentCreator('/durgasaptshati', '076'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dyaneshwar-maharaj',
                component: ComponentCreator('/dyaneshwar-maharaj', '6a0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/dyaneshwari',
                component: ComponentCreator('/dyaneshwari', '424'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/gajanan-bavanni',
                component: ComponentCreator('/gajanan-bavanni', '1d1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/gajanan-maharaj',
                component: ComponentCreator('/gajanan-maharaj', 'f58'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/gajanan-vijay-mr',
                component: ComponentCreator('/gajanan-vijay-mr', '04d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganapati-kahani',
                component: ComponentCreator('/ganapati-kahani', 'd1b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganapati-palana',
                component: ComponentCreator('/ganapati-palana', 'cdd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganapati-stotra',
                component: ComponentCreator('/ganapati-stotra', 'b64'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesh-chalisa',
                component: ComponentCreator('/ganesh-chalisa', 'a84'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-devarshi-kruta-gajanana-stotram',
                component: ComponentCreator('/ganesha-devarshi-kruta-gajanana-stotram', '589'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-dhundiraja-bhujanga-prayata-stotram',
                component: ComponentCreator('/ganesha-dhundiraja-bhujanga-prayata-stotram', '07c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-ekakshara-ganapati-kavacham',
                component: ComponentCreator('/ganesha-ekakshara-ganapati-kavacham', '9f6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-gakara-sri-ganapathi-sahasranama-stotram',
                component: ComponentCreator('/ganesha-gakara-sri-ganapathi-sahasranama-stotram', 'e85'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-gananayaka-ashtakam',
                component: ComponentCreator('/ganesha-gananayaka-ashtakam', 'e61'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-ganapathi-stava',
                component: ComponentCreator('/ganesha-ganapathi-stava', '8e9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-ganesha-divya-durga-stotram',
                component: ComponentCreator('/ganesha-ganesha-divya-durga-stotram', 'f7d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-ganesha-pancharatnam',
                component: ComponentCreator('/ganesha-ganesha-pancharatnam', 'af9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-ganesha-pratah-smarana-stotram',
                component: ComponentCreator('/ganesha-ganesha-pratah-smarana-stotram', '882'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-heramba-ganapati-stotram',
                component: ComponentCreator('/ganesha-heramba-ganapati-stotram', 'aa4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-manoratha-siddhiprada-ganesha-stotram',
                component: ComponentCreator('/ganesha-manoratha-siddhiprada-ganesha-stotram', 'b67'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-marakatha-sri-lakshmi-ganapathi-stotram',
                component: ComponentCreator('/ganesha-marakatha-sri-lakshmi-ganapathi-stotram', '248'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-mayuresha-stotram',
                component: ComponentCreator('/ganesha-mayuresha-stotram', '046'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-narada-kruta-ganapati-stotram',
                component: ComponentCreator('/ganesha-narada-kruta-ganapati-stotram', 'eb5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-pushtipati-stotram-devarshi-krutam',
                component: ComponentCreator('/ganesha-pushtipati-stotram-devarshi-krutam', '068'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-runa-hartru-ganesha-stotram',
                component: ComponentCreator('/ganesha-runa-hartru-ganesha-stotram', 'a98'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-runa-vimochana-ganesha-stotram',
                component: ComponentCreator('/ganesha-runa-vimochana-ganesha-stotram', '348'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-samsara-mohana-ganesha-kavacham',
                component: ComponentCreator('/ganesha-samsara-mohana-ganesha-kavacham', '877'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sankata-hara-chaturthi-puja-vidhanam',
                component: ComponentCreator('/ganesha-sankata-hara-chaturthi-puja-vidhanam', '8a0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sankata-nasana-ganesha-stotram',
                component: ComponentCreator('/ganesha-sankata-nasana-ganesha-stotram', '5ee'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sankata-nashana-ganesha-stotram-deva-krutam',
                component: ComponentCreator('/ganesha-sankata-nashana-ganesha-stotram-deva-krutam', 'a3e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-santhana-ganapathi-stotram',
                component: ComponentCreator('/ganesha-santhana-ganapathi-stotram', '106'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-shatru-samharaka-ekadanta-stotram',
                component: ComponentCreator('/ganesha-shatru-samharaka-ekadanta-stotram', 'd6f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-shiva-shakti-kruta-ganadhisha-stotram',
                component: ComponentCreator('/ganesha-shiva-shakti-kruta-ganadhisha-stotram', 'f4c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-shodasa-ganapathi-stavam',
                component: ComponentCreator('/ganesha-shodasa-ganapathi-stavam', 'ff9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-bhanu-vinayaka-stotram',
                component: ComponentCreator('/ganesha-sri-bhanu-vinayaka-stotram', 'b30'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-ekadanta-stotram',
                component: ComponentCreator('/ganesha-sri-ekadanta-stotram', 'da9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-ganadhipa-pancharatnam',
                component: ComponentCreator('/ganesha-sri-ganadhipa-pancharatnam', '4b9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-gananatha-stotram',
                component: ComponentCreator('/ganesha-sri-gananatha-stotram', '8c7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-ganapathi-mangalashtakam',
                component: ComponentCreator('/ganesha-sri-ganapathi-mangalashtakam', '437'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-ganapathi-stotram',
                component: ComponentCreator('/ganesha-sri-ganapathi-stotram', '54e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-ganapati-gakara-ashtottara-shatanama-stotram',
                component: ComponentCreator('/ganesha-sri-ganapati-gakara-ashtottara-shatanama-stotram', 'efc'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-ganapati-mantraksharavali-stotram',
                component: ComponentCreator('/ganesha-sri-ganapati-mantraksharavali-stotram', '22b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-ganesa-ashtottara-satanama-stotram-in-hindi',
                component: ComponentCreator('/ganesha-sri-ganesa-ashtottara-satanama-stotram-in-hindi', '72d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-ganesha-aksharamalika-stotram',
                component: ComponentCreator('/ganesha-sri-ganesha-aksharamalika-stotram', 'd5a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-ganesha-ashtakam',
                component: ComponentCreator('/ganesha-sri-ganesha-ashtakam', '3c6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-ganesha-ashtakam-vyasa-krutam',
                component: ComponentCreator('/ganesha-sri-ganesha-ashtakam-vyasa-krutam', '3d4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-ganesha-avatara-stotram',
                component: ComponentCreator('/ganesha-sri-ganesha-avatara-stotram', '3d8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-ganesha-bahya-puja',
                component: ComponentCreator('/ganesha-sri-ganesha-bahya-puja', 'ff8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-ganesha-bhujanga-stuti',
                component: ComponentCreator('/ganesha-sri-ganesha-bhujanga-stuti', '608'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-ganesha-hrudaya-kavacham',
                component: ComponentCreator('/ganesha-sri-ganesha-hrudaya-kavacham', 'dee'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-ganesha-hrudayam',
                component: ComponentCreator('/ganesha-sri-ganesha-hrudayam', '4f5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-ganesha-kavacham',
                component: ComponentCreator('/ganesha-sri-ganesha-kavacham', 'e77'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-ganesha-kilaka-stotram',
                component: ComponentCreator('/ganesha-sri-ganesha-kilaka-stotram', 'f19'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-ganesha-mahimna-stotram',
                component: ComponentCreator('/ganesha-sri-ganesha-mahimna-stotram', '532'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-ganesha-manasa-puja',
                component: ComponentCreator('/ganesha-sri-ganesha-manasa-puja', '824'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-ganesha-moola-mantra-pada-mala-stotram',
                component: ComponentCreator('/ganesha-sri-ganesha-moola-mantra-pada-mala-stotram', '155'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-ganesha-namashtakam',
                component: ComponentCreator('/ganesha-sri-ganesha-namashtakam', 'd24'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-ganesha-pancha-chamara-stotram',
                component: ComponentCreator('/ganesha-sri-ganesha-pancha-chamara-stotram', 'a38'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-ganesha-prabhava-stuti',
                component: ComponentCreator('/ganesha-sri-ganesha-prabhava-stuti', '703'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-ganesha-stotram-3-daridrya-dahanam',
                component: ComponentCreator('/ganesha-sri-ganesha-stotram-3-daridrya-dahanam', 'df4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-ganesha-stotram-agni-krutam',
                component: ComponentCreator('/ganesha-sri-ganesha-stotram-agni-krutam', 'f89'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-ganesha-vajra-panjara-stotram',
                component: ComponentCreator('/ganesha-sri-ganesha-vajra-panjara-stotram', '934'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-haridra-ganapati-puja',
                component: ComponentCreator('/ganesha-sri-haridra-ganapati-puja', '978'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-lambodara-stotram-krodhasura-krutam',
                component: ComponentCreator('/ganesha-sri-lambodara-stotram-krodhasura-krutam', 'd64'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-maha-ganapathi-chaturavrutti-tarpanam',
                component: ComponentCreator('/ganesha-sri-maha-ganapathi-chaturavrutti-tarpanam', 'e6b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-maha-ganapathi-mangala-malika-stotram',
                component: ComponentCreator('/ganesha-sri-maha-ganapathi-mangala-malika-stotram', 'e44'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-maha-ganapathi-moola-mantra',
                component: ComponentCreator('/ganesha-sri-maha-ganapathi-moola-mantra', '45e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-maha-ganapathi-sahasranama-stotram',
                component: ComponentCreator('/ganesha-sri-maha-ganapathi-sahasranama-stotram', '4bd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-maha-ganapathi-shodashopachara-puja',
                component: ComponentCreator('/ganesha-sri-maha-ganapathi-shodashopachara-puja', '6b4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-maha-ganapathi-stotram',
                component: ComponentCreator('/ganesha-sri-maha-ganapathi-stotram', '3ad'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-maha-ganapati-mantra-vigraha-kavacham',
                component: ComponentCreator('/ganesha-sri-maha-ganapati-mantra-vigraha-kavacham', '31d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-mahaganapathi-navarna-vedapada-stava',
                component: ComponentCreator('/ganesha-sri-mahaganapathi-navarna-vedapada-stava', '599'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-ratnagarbha-ganesha-vilasa-stotram',
                component: ComponentCreator('/ganesha-sri-ratnagarbha-ganesha-vilasa-stotram', 'd22'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-siddhi-vinayaka-stotram',
                component: ComponentCreator('/ganesha-sri-siddhi-vinayaka-stotram', '579'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-vallabhesha-hrudayam',
                component: ComponentCreator('/ganesha-sri-vallabhesha-hrudayam', '08d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-vallabhesha-karavalamba-stotram',
                component: ComponentCreator('/ganesha-sri-vallabhesha-karavalamba-stotram', '44a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-varada-ganesha-ashtottara-shatanama-stotram',
                component: ComponentCreator('/ganesha-sri-varada-ganesha-ashtottara-shatanama-stotram', '279'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-vighneshwara-shodasha-nama-stotram',
                component: ComponentCreator('/ganesha-sri-vighneshwara-shodasha-nama-stotram', '1a0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-vinayaka-stavaraja',
                component: ComponentCreator('/ganesha-sri-vinayaka-stavaraja', '2cc'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-sri-vinayaka-stuti',
                component: ComponentCreator('/ganesha-sri-vinayaka-stuti', 'a25'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-trailokya-mohana-ganapati-kavacham',
                component: ComponentCreator('/ganesha-trailokya-mohana-ganapati-kavacham', '129'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-ucchista-ganapati-stotram',
                component: ComponentCreator('/ganesha-ucchista-ganapati-stotram', '4a1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-vakratunda-ganesha-kavacham',
                component: ComponentCreator('/ganesha-vakratunda-ganesha-kavacham', '4cd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-vakratunda-ganesha-stavaraja',
                component: ComponentCreator('/ganesha-vakratunda-ganesha-stavaraja', '0be'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-vakratunda-stotram',
                component: ComponentCreator('/ganesha-vakratunda-stotram', '55c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganesha-yogaprada-ganesha-stotram',
                component: ComponentCreator('/ganesha-yogaprada-ganesha-stotram', 'e4e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ganpati',
                component: ComponentCreator('/ganpati', '9eb'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/garud',
                component: ComponentCreator('/garud', '70b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/gauri-dashkam',
                component: ComponentCreator('/gauri-dashkam', '232'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/gauri-mahalaxmi-poojan',
                component: ComponentCreator('/gauri-mahalaxmi-poojan', 'f1e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/gauri-namavali',
                component: ComponentCreator('/gauri-namavali', '940'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/gayatri-gayatri-ashtakam-in-hindi',
                component: ComponentCreator('/gayatri-gayatri-ashtakam-in-hindi', '9c9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/gayatri-gayatri-mantra-in-hindi',
                component: ComponentCreator('/gayatri-gayatri-mantra-in-hindi', 'a04'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/gayatri-gayatri-stotram-in-hindi',
                component: ComponentCreator('/gayatri-gayatri-stotram-in-hindi', '291'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/gayatri-sri-gayathri-ashtottara-sata-nama-stotram-in-hindi',
                component: ComponentCreator('/gayatri-sri-gayathri-ashtottara-sata-nama-stotram-in-hindi', 'ee5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/gayatri-sri-gayathri-pancha-upachara-puja',
                component: ComponentCreator('/gayatri-sri-gayathri-pancha-upachara-puja', 'cf9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/gayatri-sri-gayatri-aksharavalli-stotram',
                component: ComponentCreator('/gayatri-sri-gayatri-aksharavalli-stotram', 'ea7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/gayatri-sri-gayatri-ashtakam-2',
                component: ComponentCreator('/gayatri-sri-gayatri-ashtakam-2', '759'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/gayatri-sri-gayatri-ashtottara-shatanama-stotram-1',
                component: ComponentCreator('/gayatri-sri-gayatri-ashtottara-shatanama-stotram-1', '96b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/gayatri-sri-gayatri-bhujanga-stotram-in-hindi',
                component: ComponentCreator('/gayatri-sri-gayatri-bhujanga-stotram-in-hindi', '58b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/gayatri-sri-gayatri-hrudayam',
                component: ComponentCreator('/gayatri-sri-gayatri-hrudayam', 'b59'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/gayatri-sri-gayatri-kavacham',
                component: ComponentCreator('/gayatri-sri-gayatri-kavacham', '28f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/gayatri-sri-gayatri-kavacham-2',
                component: ComponentCreator('/gayatri-sri-gayatri-kavacham-2', 'eaf'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/gayatri-sri-gayatri-mantra-kavacham',
                component: ComponentCreator('/gayatri-sri-gayatri-mantra-kavacham', '4ad'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/gayatri-sri-gayatri-panjara-stotram',
                component: ComponentCreator('/gayatri-sri-gayatri-panjara-stotram', 'c98'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/gayatri-sri-gayatri-stavaraja',
                component: ComponentCreator('/gayatri-sri-gayatri-stavaraja', '402'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/gayatri-sri-gayatri-stotram-2',
                component: ComponentCreator('/gayatri-sri-gayatri-stotram-2', 'ff6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/gayatri-sri-gayatri-tattva-mala-mantram',
                component: ComponentCreator('/gayatri-sri-gayatri-tattva-mala-mantram', '8f5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/gayatri-vividha-gayatri-mantrani-in-hindi',
                component: ComponentCreator('/gayatri-vividha-gayatri-mantrani-in-hindi', 'f8a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ghalin-lotangan',
                component: ComponentCreator('/ghalin-lotangan', '206'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ghat-sthapana-puja',
                component: ComponentCreator('/ghat-sthapana-puja', 'ac8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ghoratkashtat',
                component: ComponentCreator('/ghoratkashtat', 'e9e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/giriraj-chalisa',
                component: ComponentCreator('/giriraj-chalisa', 'b58'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/gondavalekar-maharaj',
                component: ComponentCreator('/gondavalekar-maharaj', '0b6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/gopdama-kahani',
                component: ComponentCreator('/gopdama-kahani', 'e50'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/guru-charitra',
                component: ComponentCreator('/guru-charitra', '624'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/gurupaduka-ashtakam',
                component: ComponentCreator('/gurupaduka-ashtakam', 'd6d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/hanuman',
                component: ComponentCreator('/hanuman', '30a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/hanuman-chalisa',
                component: ComponentCreator('/hanuman-chalisa', '5c8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/hanuman-stuti',
                component: ComponentCreator('/hanuman-stuti', '1cd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/haritalika-aarati',
                component: ComponentCreator('/haritalika-aarati', 'fa6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/haritalika-katha',
                component: ComponentCreator('/haritalika-katha', 'cf3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/indrayani-kathi',
                component: ComponentCreator('/indrayani-kathi', '8a6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jai-devi-saptshrung',
                component: ComponentCreator('/jai-devi-saptshrung', '163'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jata-pandharisi',
                component: ComponentCreator('/jata-pandharisi', '97d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/je-ka-ranjale',
                component: ComponentCreator('/je-ka-ranjale', '992'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jestha-gauri-kahani',
                component: ComponentCreator('/jestha-gauri-kahani', 'aef'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jestha-gauri-mahalaxmi',
                component: ComponentCreator('/jestha-gauri-mahalaxmi', '96f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jestha-gauri-mahalaxmi-day-1',
                component: ComponentCreator('/jestha-gauri-mahalaxmi-day-1', '28c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jestha-gauri-mahalaxmi-day-2',
                component: ComponentCreator('/jestha-gauri-mahalaxmi-day-2', '827'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jestha-gauri-mahalaxmi-day-3',
                component: ComponentCreator('/jestha-gauri-mahalaxmi-day-3', 'fcc'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jestha-gauri-mahalaxmi-maharashtra-outside-maharashtra',
                component: ComponentCreator('/jestha-gauri-mahalaxmi-maharashtra-outside-maharashtra', '02c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jestha-gauri-puran-katha',
                component: ComponentCreator('/jestha-gauri-puran-katha', 'c65'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jestha-gauri-resources',
                component: ComponentCreator('/jestha-gauri-resources', '7dd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jivtichi-katha',
                component: ComponentCreator('/jivtichi-katha', 'b9e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jogeshwarichi-aarati',
                component: ComponentCreator('/jogeshwarichi-aarati', 'ef7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/jyacha-sakha',
                component: ComponentCreator('/jyacha-sakha', '512'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/kalbhairav-ashtak',
                component: ComponentCreator('/kalbhairav-ashtak', '208'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/kalika-ashtak',
                component: ComponentCreator('/kalika-ashtak', 'ac9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/kalubai-aarati',
                component: ComponentCreator('/kalubai-aarati', '572'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/kanhoba-nivadi-aapli',
                component: ComponentCreator('/kanhoba-nivadi-aapli', '631'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/karpur',
                component: ComponentCreator('/karpur', '426'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/karuna-tripadi',
                component: ComponentCreator('/karuna-tripadi', '8bb'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/kasa-mala-takuni-gela-ram',
                component: ComponentCreator('/kasa-mala-takuni-gela-ram', '181'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/kaya-hi-pandhari',
                component: ComponentCreator('/kaya-hi-pandhari', 'f58'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/khandoba',
                component: ComponentCreator('/khandoba', 'c29'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/kilak-stotra',
                component: ComponentCreator('/kilak-stotra', '704'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/krushna-aarati',
                component: ComponentCreator('/krushna-aarati', '74d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/krushna-chalisa',
                component: ComponentCreator('/krushna-chalisa', 'e53'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/krushna-palana',
                component: ComponentCreator('/krushna-palana', '7eb'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/kshama-stotra',
                component: ComponentCreator('/kshama-stotra', 'ab3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/kuber-chalisa',
                component: ComponentCreator('/kuber-chalisa', 'ab0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/laghunyas',
                component: ComponentCreator('/laghunyas', 'd10'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lakshmi-ashtalakshmi-stotram-in-hindi',
                component: ComponentCreator('/lakshmi-ashtalakshmi-stotram-in-hindi', '84f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lakshmi-deepa-lakshmi-stavam',
                component: ComponentCreator('/lakshmi-deepa-lakshmi-stavam', '745'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lakshmi-deepa-lakshmi-stotram',
                component: ComponentCreator('/lakshmi-deepa-lakshmi-stotram', '46f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lakshmi-kanakadhara-stotram-in-hindi',
                component: ComponentCreator('/lakshmi-kanakadhara-stotram-in-hindi', 'cac'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lakshmi-kanakadhara-stotram-variation',
                component: ComponentCreator('/lakshmi-kanakadhara-stotram-variation', '83c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lakshmi-lopamudra-kruta-sri-lakshmi-stotram',
                component: ComponentCreator('/lakshmi-lopamudra-kruta-sri-lakshmi-stotram', 'a8c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lakshmi-mahalakshmi-ashtakam-in-hindi',
                component: ComponentCreator('/lakshmi-mahalakshmi-ashtakam-in-hindi', 'a2c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lakshmi-sri-bhadra-lakshmi-stotram',
                component: ComponentCreator('/lakshmi-sri-bhadra-lakshmi-stotram', '319'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lakshmi-sri-dhana-lakshmi-stotram',
                component: ComponentCreator('/lakshmi-sri-dhana-lakshmi-stotram', '829'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lakshmi-sri-indira-ashtottara-shatanama-stotram',
                component: ComponentCreator('/lakshmi-sri-indira-ashtottara-shatanama-stotram', '0ac'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lakshmi-sri-lakshmi-ashtaka-stotram-in-hindi',
                component: ComponentCreator('/lakshmi-sri-lakshmi-ashtaka-stotram-in-hindi', '263'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lakshmi-sri-lakshmi-ashtottara-satanama-stotram',
                component: ComponentCreator('/lakshmi-sri-lakshmi-ashtottara-satanama-stotram', '6bf'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lakshmi-sri-lakshmi-ashtottara-shatanama-stotram-2',
                component: ComponentCreator('/lakshmi-sri-lakshmi-ashtottara-shatanama-stotram-2', '4ef'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lakshmi-sri-lakshmi-ashtottara-shatanama-stotram-3',
                component: ComponentCreator('/lakshmi-sri-lakshmi-ashtottara-shatanama-stotram-3', '91f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lakshmi-sri-lakshmi-gadyam-in-hindi',
                component: ComponentCreator('/lakshmi-sri-lakshmi-gadyam-in-hindi', '6d6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lakshmi-sri-lakshmi-gayatri-mantra-stuti-in-hindi',
                component: ComponentCreator('/lakshmi-sri-lakshmi-gayatri-mantra-stuti-in-hindi', 'c4e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lakshmi-sri-lakshmi-hrudaya-stotram-in-hindi',
                component: ComponentCreator('/lakshmi-sri-lakshmi-hrudaya-stotram-in-hindi', '850'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lakshmi-sri-lakshmi-kavacham',
                component: ComponentCreator('/lakshmi-sri-lakshmi-kavacham', '9fc'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lakshmi-sri-lakshmi-sahasranama-stotram',
                component: ComponentCreator('/lakshmi-sri-lakshmi-sahasranama-stotram', '86f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lakshmi-sri-lakshmi-stotram-agastya-rachitam',
                component: ComponentCreator('/lakshmi-sri-lakshmi-stotram-agastya-rachitam', 'b48'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lakshmi-sri-lakshmi-stotram-indra-rachitam-in-hindi',
                component: ComponentCreator('/lakshmi-sri-lakshmi-stotram-indra-rachitam-in-hindi', '0db'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lakshmi-sri-lakshmi-stotram-sarva-deva-kritam-in-hindi',
                component: ComponentCreator('/lakshmi-sri-lakshmi-stotram-sarva-deva-kritam-in-hindi', '3a9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lakshmi-sri-maha-lakshmi-visesha-shodasopachara-puja',
                component: ComponentCreator('/lakshmi-sri-maha-lakshmi-visesha-shodasopachara-puja', '44a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lakshmi-sri-mahalakshmi-aksharamalika-namavali',
                component: ComponentCreator('/lakshmi-sri-mahalakshmi-aksharamalika-namavali', '3a5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lakshmi-sri-mahalakshmi-chaturvimsati-nama-stotram',
                component: ComponentCreator('/lakshmi-sri-mahalakshmi-chaturvimsati-nama-stotram', 'b5c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lakshmi-sri-mahalakshmi-kavacham-1',
                component: ComponentCreator('/lakshmi-sri-mahalakshmi-kavacham-1', '608'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lakshmi-sri-mahalakshmi-kavacham-2',
                component: ComponentCreator('/lakshmi-sri-mahalakshmi-kavacham-2', '666'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lakshmi-sri-mahalakshmi-sahasranama-stotram',
                component: ComponentCreator('/lakshmi-sri-mahalakshmi-sahasranama-stotram', 'b06'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lakshmi-sri-mahalakshmi-stava',
                component: ComponentCreator('/lakshmi-sri-mahalakshmi-stava', '6f3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lakshmi-sri-padma-kavacham',
                component: ComponentCreator('/lakshmi-sri-padma-kavacham', '494'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lakshmi-sri-padmavathi-stotram',
                component: ComponentCreator('/lakshmi-sri-padmavathi-stotram', '9ba'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lakshmi-sri-padmavati-navaratna-malika-stuti',
                component: ComponentCreator('/lakshmi-sri-padmavati-navaratna-malika-stuti', '39a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lakshmi-sri-siddha-lakshmi-stotram-variation-in-devanagari',
                component: ComponentCreator('/lakshmi-sri-siddha-lakshmi-stotram-variation-in-devanagari', 'c95'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lakshmi-sri-siddhi-lakshmi-stuti-in-hindi',
                component: ComponentCreator('/lakshmi-sri-siddhi-lakshmi-stuti-in-hindi', '06c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lakshmi-sri-stotram-agni-purana-in-hindi',
                component: ComponentCreator('/lakshmi-sri-stotram-agni-purana-in-hindi', 'c35'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lakshmi-trailokya-mangala-lakshmi-stotram',
                component: ComponentCreator('/lakshmi-trailokya-mangala-lakshmi-stotram', '317'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lalita-sahasranam',
                component: ComponentCreator('/lalita-sahasranam', '506'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lalitapanchami-katha',
                component: ComponentCreator('/lalitapanchami-katha', 'c68'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lalitha-devi-vaibhava-ashcharya-ashtottara-shatanama-stotram',
                component: ComponentCreator('/lalitha-devi-vaibhava-ashcharya-ashtottara-shatanama-stotram', '0ce'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lalitha-lalitha-pancharatnam-in-hindi',
                component: ComponentCreator('/lalitha-lalitha-pancharatnam-in-hindi', '496'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lalitha-mantra-matrika-pushpa-mala-stava',
                component: ComponentCreator('/lalitha-mantra-matrika-pushpa-mala-stava', '16b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lalitha-sarva-devata-kruta-lalitha-stotram',
                component: ComponentCreator('/lalitha-sarva-devata-kruta-lalitha-stotram', '644'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lalitha-saundaryalahari-in-hindi',
                component: ComponentCreator('/lalitha-saundaryalahari-in-hindi', 'c38'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lalitha-sri-kamakshi-stotram-2',
                component: ComponentCreator('/lalitha-sri-kamakshi-stotram-2', '7e8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lalitha-sri-kamakshi-stotram-3-brahma-krutam',
                component: ComponentCreator('/lalitha-sri-kamakshi-stotram-3-brahma-krutam', 'dff'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lalitha-sri-kamakshi-stotram-4-paramacharya-krutam',
                component: ComponentCreator('/lalitha-sri-kamakshi-stotram-4-paramacharya-krutam', '0ec'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lalitha-sri-lalita-lakaradi-shatanama-stotram',
                component: ComponentCreator('/lalitha-sri-lalita-lakaradi-shatanama-stotram', 'f44'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lalitha-sri-lalitha-arya-kavacham',
                component: ComponentCreator('/lalitha-sri-lalitha-arya-kavacham', 'e1d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lalitha-sri-lalitha-ashtakarika-stotram',
                component: ComponentCreator('/lalitha-sri-lalitha-ashtakarika-stotram', '269'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lalitha-sri-lalitha-ashtottara-shatanama-stotram-2',
                component: ComponentCreator('/lalitha-sri-lalitha-ashtottara-shatanama-stotram-2', 'ea8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lalitha-sri-lalitha-kavacham',
                component: ComponentCreator('/lalitha-sri-lalitha-kavacham', '252'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lalitha-sri-lalitha-moola-mantra-kavacham',
                component: ComponentCreator('/lalitha-sri-lalitha-moola-mantra-kavacham', 'e07'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lalitha-sri-lalitha-panchavimsati-nama-stotram',
                component: ComponentCreator('/lalitha-sri-lalitha-panchavimsati-nama-stotram', 'd56'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lalitha-sri-lalitha-sahasranama-stotram-poorvapeetika-in-hindi',
                component: ComponentCreator('/lalitha-sri-lalitha-sahasranama-stotram-poorvapeetika-in-hindi', 'c45'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lalitha-sri-lalitha-shodasopachara-puja-vidhanam',
                component: ComponentCreator('/lalitha-sri-lalitha-shodasopachara-puja-vidhanam', 'b0e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lalitha-sri-lalitha-stavaraja-stotram',
                component: ComponentCreator('/lalitha-sri-lalitha-stavaraja-stotram', '428'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lalitha-sri-lalitha-stotram-brahmaadi-krutam',
                component: ComponentCreator('/lalitha-sri-lalitha-stotram-brahmaadi-krutam', '3ce'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lalitha-sri-lalitha-trisathi-namavali-in-hindi',
                component: ComponentCreator('/lalitha-sri-lalitha-trisathi-namavali-in-hindi', 'd2d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lalitha-sri-lalitha-trisati-stotram-in-hindi',
                component: ComponentCreator('/lalitha-sri-lalitha-trisati-stotram-in-hindi', 'e69'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lalitha-sri-lalitha-trisati-stotram-poorvapeetika-in-hindi',
                component: ComponentCreator('/lalitha-sri-lalitha-trisati-stotram-poorvapeetika-in-hindi', '4c9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lalitha-sri-lalithamba-parameshwara-stava',
                component: ComponentCreator('/lalitha-sri-lalithamba-parameshwara-stava', 'f9b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lalitha-sri-maha-varahi-sri-padukarchana-ashtottara-shatanamavali',
                component: ComponentCreator('/lalitha-sri-maha-varahi-sri-padukarchana-ashtottara-shatanamavali', 'a0c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lalitha-sri-rajarajeshwari-churnika',
                component: ComponentCreator('/lalitha-sri-rajarajeshwari-churnika', '496'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lalitha-sri-rajarajeshwari-stava',
                component: ComponentCreator('/lalitha-sri-rajarajeshwari-stava', 'a77'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lalitha-sri-rajarajeswari-mantra-matruka-stava',
                component: ComponentCreator('/lalitha-sri-rajarajeswari-mantra-matruka-stava', 'e85'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lalitha-sri-rajni-stotram',
                component: ComponentCreator('/lalitha-sri-rajni-stotram', 'b76'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lalitha-sri-tripura-sundari-stotram-2',
                component: ComponentCreator('/lalitha-sri-tripura-sundari-stotram-2', '377'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/lalitha-sri-tripurasundari-dandakam',
                component: ComponentCreator('/lalitha-sri-tripurasundari-dandakam', '214'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/laxmi-shahtra-namavali',
                component: ComponentCreator('/laxmi-shahtra-namavali', '372'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/madhura-ashtak',
                component: ComponentCreator('/madhura-ashtak', '65e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/mahakali-aarati',
                component: ComponentCreator('/mahakali-aarati', '835'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/mahalaxmi',
                component: ComponentCreator('/mahalaxmi', 'a92'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/mahalaxmi-ashtakam',
                component: ComponentCreator('/mahalaxmi-ashtakam', 'e9b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/mahalaxmi-gauri',
                component: ComponentCreator('/mahalaxmi-gauri', '288'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/mahalaxmi-stuti',
                component: ComponentCreator('/mahalaxmi-stuti', '23c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/manache-shlok-stotra',
                component: ComponentCreator('/manache-shlok-stotra', '920'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/managalagaurichi-aarati',
                component: ComponentCreator('/managalagaurichi-aarati', '001'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/mangalagaur-katha',
                component: ComponentCreator('/mangalagaur-katha', '976'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/mantra-pushpam',
                component: ComponentCreator('/mantra-pushpam', '04d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/mantras-sri-vipareeta-pratyangira-mantra',
                component: ComponentCreator('/mantras-sri-vipareeta-pratyangira-mantra', '75a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/manyu-sukta',
                component: ComponentCreator('/manyu-sukta', '2ad'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/mauli-mauli',
                component: ComponentCreator('/mauli-mauli', '541'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/munj-mangal-asthsk',
                component: ComponentCreator('/munj-mangal-asthsk', 'fdf'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/naga-devata-sri-manasa-devi-dwadasa-nama-stotram-naga-bhaya-nivarana-stotram',
                component: ComponentCreator('/naga-devata-sri-manasa-devi-dwadasa-nama-stotram-naga-bhaya-nivarana-stotram', '053'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/naga-devata-sri-manasa-devi-stotram-dhanvantari-krutam',
                component: ComponentCreator('/naga-devata-sri-manasa-devi-stotram-dhanvantari-krutam', '0db'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/naga-devata-sri-manasa-devi-stotram-mahendra-krutam',
                component: ComponentCreator('/naga-devata-sri-manasa-devi-stotram-mahendra-krutam', 'ec1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/nagpanchami-katha',
                component: ComponentCreator('/nagpanchami-katha', 'be4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/namacha-gajar',
                component: ComponentCreator('/namacha-gajar', 'd51'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/nana-maharaj',
                component: ComponentCreator('/nana-maharaj', '4f6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/narayan-sukta',
                component: ComponentCreator('/narayan-sukta', '954'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/narmada',
                component: ComponentCreator('/narmada', '467'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/narmada-ashtak',
                component: ComponentCreator('/narmada-ashtak', 'cf5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navagraha-suktam',
                component: ComponentCreator('/navagraha-suktam', 'b9d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navgrah-stotra',
                component: ComponentCreator('/navgrah-stotra', '2dc'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navgraha-chalisa',
                component: ComponentCreator('/navgraha-chalisa', 'f2e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnag-stotra',
                component: ComponentCreator('/navnag-stotra', 'acd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-aarati',
                component: ComponentCreator('/navnath-aarati', '3e5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-1',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-1', 'e7b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-10',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-10', '302'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-11',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-11', '37e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-12',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-12', 'e94'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-13',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-13', '34c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-14',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-14', 'e19'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-15',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-15', '11a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-16',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-16', '04e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-17',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-17', '46b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-18',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-18', 'f43'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-19',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-19', 'c93'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-2',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-2', '4fc'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-20',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-20', '44b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-21',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-21', '070'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-22',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-22', '130'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-23',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-23', '494'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-24',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-24', 'c77'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-25',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-25', 'bfa'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-26',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-26', '938'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-27',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-27', '7c3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-28',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-28', '9c6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-29',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-29', '0b4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-3',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-3', 'adb'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-30',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-30', '35c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-31',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-31', '960'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-32',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-32', '312'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-33',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-33', '182'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-34',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-34', '278'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-35',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-35', 'aa6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-36',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-36', 'ca6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-37',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-37', '3b4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-38',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-38', 'd7c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-39',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-39', '1cd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-4',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-4', 'c2b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-40',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-40', '43e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-5',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-5', '31b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-6',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-6', 'cc9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-7',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-7', '36d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-8',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-8', '31d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/navnath-bhaktisar-adhyay-9',
                component: ComponentCreator('/navnath-bhaktisar-adhyay-9', '956'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/niranjan',
                component: ComponentCreator('/niranjan', 'b08'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/nirop',
                component: ComponentCreator('/nirop', '5d2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/nrusinh-sarswati-maharaj-aarati',
                component: ComponentCreator('/nrusinh-sarswati-maharaj-aarati', 'edc'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/nrusinha',
                component: ComponentCreator('/nrusinha', '0fc'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/pacha-devanchi-kahani',
                component: ComponentCreator('/pacha-devanchi-kahani', '14c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/panchayatan',
                component: ComponentCreator('/panchayatan', '084'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/pandhari-nivasa',
                component: ComponentCreator('/pandhari-nivasa', 'ef6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/parshuram-chalisa',
                component: ComponentCreator('/parshuram-chalisa', '9a0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/parshuram-palana',
                component: ComponentCreator('/parshuram-palana', 'aae'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/parshuram-stotram',
                component: ComponentCreator('/parshuram-stotram', 'e25'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/parthiv-ganesh-pratishthapana',
                component: ComponentCreator('/parthiv-ganesh-pratishthapana', '7c5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/pasaydan',
                component: ComponentCreator('/pasaydan', '8d5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/pashupati-ashtak',
                component: ComponentCreator('/pashupati-ashtak', '5c4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/pavalo-pandhari',
                component: ComponentCreator('/pavalo-pandhari', 'a09'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/pitru-sukta',
                component: ComponentCreator('/pitru-sukta', '72f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/pitrupaksha',
                component: ComponentCreator('/pitrupaksha', '5a0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/pradosh-stotra',
                component: ComponentCreator('/pradosh-stotra', '8e8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/pratyangira-sri-bagala-pratyangira-kavacham',
                component: ComponentCreator('/pratyangira-sri-bagala-pratyangira-kavacham', '2c2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/pratyangira-sri-kali-pratyangira-mala-mantram-stotram',
                component: ComponentCreator('/pratyangira-sri-kali-pratyangira-mala-mantram-stotram', 'b70'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/pratyangira-sri-pratyangira-apannivarana-stuti',
                component: ComponentCreator('/pratyangira-sri-pratyangira-apannivarana-stuti', '37b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/pratyangira-sri-pratyangira-dandakam',
                component: ComponentCreator('/pratyangira-sri-pratyangira-dandakam', 'bb6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/pratyangira-sri-pratyangira-devi-mala-mantram-1',
                component: ComponentCreator('/pratyangira-sri-pratyangira-devi-mala-mantram-1', '1fe'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/pratyangira-sri-pratyangira-kavacham-1-sarvartha-sadhanam',
                component: ComponentCreator('/pratyangira-sri-pratyangira-kavacham-1-sarvartha-sadhanam', '8f9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/pratyangira-sri-pratyangira-kavacham-2-jaganmangalam',
                component: ComponentCreator('/pratyangira-sri-pratyangira-kavacham-2-jaganmangalam', 'df3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/pratyangira-sri-pratyangira-khadgamala-stotram',
                component: ComponentCreator('/pratyangira-sri-pratyangira-khadgamala-stotram', '7bf'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/pratyangira-sri-pratyangira-sahasrakshari-mantra',
                component: ComponentCreator('/pratyangira-sri-pratyangira-sahasrakshari-mantra', 'f69'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/pratyangira-sri-pratyangira-sahasranama-stotram',
                component: ComponentCreator('/pratyangira-sri-pratyangira-sahasranama-stotram', '425'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/pratyangira-sri-pratyangira-stavaraja',
                component: ComponentCreator('/pratyangira-sri-pratyangira-stavaraja', 'd69'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/pratyangira-sri-pratyangira-stotram-1',
                component: ComponentCreator('/pratyangira-sri-pratyangira-stotram-1', '991'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/pratyangira-sri-pratyangira-stotram-2',
                component: ComponentCreator('/pratyangira-sri-pratyangira-stotram-2', '8d2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/pratyangira-sri-pratyangira-stotram-3',
                component: ComponentCreator('/pratyangira-sri-pratyangira-stotram-3', 'fa8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/pratyangira-sri-pratyangira-suktam-atharva-vedoktam',
                component: ComponentCreator('/pratyangira-sri-pratyangira-suktam-atharva-vedoktam', '074'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/pratyangira-sri-pratyangira-suktam-rigveda-variation-1',
                component: ComponentCreator('/pratyangira-sri-pratyangira-suktam-rigveda-variation-1', '59e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/pratyangira-sri-pratyangira-suktam-rigveda-variation-2',
                component: ComponentCreator('/pratyangira-sri-pratyangira-suktam-rigveda-variation-2', '7d1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/pratyangira-sri-tara-pratyangira-kavacham',
                component: ComponentCreator('/pratyangira-sri-tara-pratyangira-kavacham', 'cab'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/pratyangira-sri-vipareeta-pratyangira-mala-mantram',
                component: ComponentCreator('/pratyangira-sri-vipareeta-pratyangira-mala-mantram', 'c75'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/pratyangira-sri-vipareeta-pratyangira-stotram',
                component: ComponentCreator('/pratyangira-sri-vipareeta-pratyangira-stotram', '885'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/pratyangira-trailokya-vijaya-sri-pratyangira-kavacham',
                component: ComponentCreator('/pratyangira-trailokya-vijaya-sri-pratyangira-kavacham', '3f5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/project-information',
                component: ComponentCreator('/project-information', 'c86'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/puja-vidhi-sri-bala-tripura-sundari-shodasopachara-puja',
                component: ComponentCreator('/puja-vidhi-sri-bala-tripura-sundari-shodasopachara-puja', '922'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/puja-vidhi-sri-gayatri-shodasopachara-puja-vidhanam',
                component: ComponentCreator('/puja-vidhi-sri-gayatri-shodasopachara-puja-vidhanam', '287'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/puja-vidhi-sri-gowri-pooja-vidhanam',
                component: ComponentCreator('/puja-vidhi-sri-gowri-pooja-vidhanam', '52b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/puja-vidhi-sri-maha-kali-shodasopachara-puja',
                component: ComponentCreator('/puja-vidhi-sri-maha-kali-shodasopachara-puja', '43b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/puja-vidhi-sri-parameshwara-seeghra-pooja-vidhanam',
                component: ComponentCreator('/puja-vidhi-sri-parameshwara-seeghra-pooja-vidhanam', '026'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/puja-vidhi-sri-saraswathi-shodasopachara-puja',
                component: ComponentCreator('/puja-vidhi-sri-saraswathi-shodasopachara-puja', '7a6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/puja-vidhi-sri-shiva-shodasopachara-puja',
                component: ComponentCreator('/puja-vidhi-sri-shiva-shodasopachara-puja', 'f94'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/puja-vidhi-sri-shyamala-devi-pooja-vidhanam',
                component: ComponentCreator('/puja-vidhi-sri-shyamala-devi-pooja-vidhanam', 'd9e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/puja-vidhi-sri-subrahmanya-pooja-vidhanam',
                component: ComponentCreator('/puja-vidhi-sri-subrahmanya-pooja-vidhanam', 'db3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/puja-vidhi-sri-varahi-devi-shodasopachara-puja',
                component: ComponentCreator('/puja-vidhi-sri-varahi-devi-shodasopachara-puja', 'e5a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/purush-sukt',
                component: ComponentCreator('/purush-sukt', 'de3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/raama-sri-shiva-rama-ashtakam',
                component: ComponentCreator('/raama-sri-shiva-rama-ashtakam', 'aea'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/raghupati-raghav',
                component: ComponentCreator('/raghupati-raghav', '071'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/rajas-sukumar',
                component: ComponentCreator('/rajas-sukumar', 'dbd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/rakhi-pournima-katha',
                component: ComponentCreator('/rakhi-pournima-katha', '9ef'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ram-chalisa',
                component: ComponentCreator('/ram-chalisa', 'f80'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ram-raksha',
                component: ComponentCreator('/ram-raksha', '6e2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ramacha-palana',
                component: ComponentCreator('/ramacha-palana', '1d5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ramdev-chalisa',
                component: ComponentCreator('/ramdev-chalisa', 'e64'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/renuka-ashtak',
                component: ComponentCreator('/renuka-ashtak', '991'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/renuka-mata',
                component: ComponentCreator('/renuka-mata', '2ee'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/roop-pahata',
                component: ComponentCreator('/roop-pahata', '471'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/rudra-suktam',
                component: ComponentCreator('/rudra-suktam', 'c66'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/rushipanchami-katha',
                component: ComponentCreator('/rushipanchami-katha', '51d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/sagunachi-shej',
                component: ComponentCreator('/sagunachi-shej', '388'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saibaba-aarati',
                component: ComponentCreator('/saibaba-aarati', '85b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/sanatan-gopal-stotra',
                component: ComponentCreator('/sanatan-gopal-stotra', '723'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/sant-tukaram-maharaj-aarati',
                component: ComponentCreator('/sant-tukaram-maharaj-aarati', 'df1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sharada-bhujanga-prayata-ashtakam',
                component: ComponentCreator('/saraswati-sharada-bhujanga-prayata-ashtakam', 'f31'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sri-bharati-bhavana-stotram',
                component: ComponentCreator('/saraswati-sri-bharati-bhavana-stotram', 'c9b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sri-bhavasodari-ashtakam',
                component: ComponentCreator('/saraswati-sri-bhavasodari-ashtakam', '710'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sri-kamalajadayita-ashtakam',
                component: ComponentCreator('/saraswati-sri-kamalajadayita-ashtakam', 'd88'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sri-maha-saraswati-stavam',
                component: ComponentCreator('/saraswati-sri-maha-saraswati-stavam', 'fad'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sri-saraswathi-dvadasanama-stotram',
                component: ComponentCreator('/saraswati-sri-saraswathi-dvadasanama-stotram', '871'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sri-saraswathi-stotram-skandapurane-ambuvichiraja-krutam',
                component: ComponentCreator('/saraswati-sri-saraswathi-stotram-skandapurane-ambuvichiraja-krutam', 'a49'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sri-saraswati-ashtakam',
                component: ComponentCreator('/saraswati-sri-saraswati-ashtakam', 'aa0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sri-saraswati-ashtottara-satanama-stotram',
                component: ComponentCreator('/saraswati-sri-saraswati-ashtottara-satanama-stotram', '953'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sri-saraswati-dasha-shloki-stuti',
                component: ComponentCreator('/saraswati-sri-saraswati-dasha-shloki-stuti', 'f1d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sri-saraswati-kavacham',
                component: ComponentCreator('/saraswati-sri-saraswati-kavacham', '759'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sri-saraswati-kavacham-variation',
                component: ComponentCreator('/saraswati-sri-saraswati-kavacham-variation', 'fed'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sri-saraswati-nakshatra-mala-stava',
                component: ComponentCreator('/saraswati-sri-saraswati-nakshatra-mala-stava', '389'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sri-saraswati-sahasranama-stotram',
                component: ComponentCreator('/saraswati-sri-saraswati-sahasranama-stotram', '42e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sri-saraswati-sarasashanti-sudharasa-stotram',
                component: ComponentCreator('/saraswati-sri-saraswati-sarasashanti-sudharasa-stotram', '6fe'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sri-saraswati-stavam-1-brahma-krutam',
                component: ComponentCreator('/saraswati-sri-saraswati-stavam-1-brahma-krutam', '56d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sri-saraswati-stavam-2',
                component: ComponentCreator('/saraswati-sri-saraswati-stavam-2', '906'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sri-saraswati-stavam-vasudevananda-saraswati-krutam',
                component: ComponentCreator('/saraswati-sri-saraswati-stavam-vasudevananda-saraswati-krutam', 'f25'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sri-saraswati-stotram-1',
                component: ComponentCreator('/saraswati-sri-saraswati-stotram-1', '8c0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sri-saraswati-stotram-2',
                component: ComponentCreator('/saraswati-sri-saraswati-stotram-2', 'bc4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sri-saraswati-stotram-3',
                component: ComponentCreator('/saraswati-sri-saraswati-stotram-3', '7b5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sri-saraswati-stotram-rudrayamale-bruhaspati-krutam',
                component: ComponentCreator('/saraswati-sri-saraswati-stotram-rudrayamale-bruhaspati-krutam', '1b7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sri-saraswati-stotram-vamana-purane-markandeya-krutam',
                component: ComponentCreator('/saraswati-sri-saraswati-stotram-vamana-purane-markandeya-krutam', '8c6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sri-saraswati-stotram-yajnavalkya-kritam',
                component: ComponentCreator('/saraswati-sri-saraswati-stotram-yajnavalkya-kritam', '925'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sri-saraswati-stuti-varaha-purane-brahma-krutam',
                component: ComponentCreator('/saraswati-sri-saraswati-stuti-varaha-purane-brahma-krutam', '51f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sri-saraswati-stuti-vasudevananda-saraswati-krutam',
                component: ComponentCreator('/saraswati-sri-saraswati-stuti-vasudevananda-saraswati-krutam', '567'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sri-sharada-bhujanga-prayata-stuti',
                component: ComponentCreator('/saraswati-sri-sharada-bhujanga-prayata-stuti', '524'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sri-sharada-dashakam',
                component: ComponentCreator('/saraswati-sri-sharada-dashakam', 'ffd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sri-sharada-pancharatna-stotram',
                component: ComponentCreator('/saraswati-sri-sharada-pancharatna-stotram', 'fd9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sri-sharada-pancharatna-stuti',
                component: ComponentCreator('/saraswati-sri-sharada-pancharatna-stuti', '061'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sri-sharada-stava-kadambam',
                component: ComponentCreator('/saraswati-sri-sharada-stava-kadambam', 'a56'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sri-sharada-stuti',
                component: ComponentCreator('/saraswati-sri-sharada-stuti', 'f43'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sri-siddha-saraswati-stotram',
                component: ComponentCreator('/saraswati-sri-siddha-saraswati-stotram', '863'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sri-vagdevi-stava',
                component: ComponentCreator('/saraswati-sri-vagdevi-stava', '407'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sri-vagvadini-sahasranama-stotram',
                component: ComponentCreator('/saraswati-sri-vagvadini-sahasranama-stotram', '590'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sri-vagvadini-shatkam',
                component: ComponentCreator('/saraswati-sri-vagvadini-shatkam', '603'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sri-vani-prashnamala-stava',
                component: ComponentCreator('/saraswati-sri-vani-prashnamala-stava', 'fc7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sri-vani-sharanagati-stotram',
                component: ComponentCreator('/saraswati-sri-vani-sharanagati-stotram', 'efe'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sri-vasara-saraswati-stotram',
                component: ComponentCreator('/saraswati-sri-vasara-saraswati-stotram', '8ac'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-sri-vidhi-manasa-hamsa-stotram',
                component: ComponentCreator('/saraswati-sri-vidhi-manasa-hamsa-stotram', '542'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/saraswati-stavan-stotra',
                component: ComponentCreator('/saraswati-stavan-stotra', '784'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/sarswati-aarati',
                component: ComponentCreator('/sarswati-aarati', '5f7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/sarswati-stotra',
                component: ComponentCreator('/sarswati-stotra', '770'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/satyanarayan-aarati',
                component: ComponentCreator('/satyanarayan-aarati', '54c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/satyanarayan-katha-1',
                component: ComponentCreator('/satyanarayan-katha-1', '932'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/satyanarayan-katha-2',
                component: ComponentCreator('/satyanarayan-katha-2', '492'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/satyanarayan-katha-3',
                component: ComponentCreator('/satyanarayan-katha-3', '4f7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/satyanarayan-katha-4',
                component: ComponentCreator('/satyanarayan-katha-4', '9e4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/satyanarayan-katha-5',
                component: ComponentCreator('/satyanarayan-katha-5', '355'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/savale-sundar',
                component: ComponentCreator('/savale-sundar', '137'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shani-chalisa',
                component: ComponentCreator('/shani-chalisa', '0b9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shanidev-aarati',
                component: ComponentCreator('/shanidev-aarati', '096'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shankar',
                component: ComponentCreator('/shankar', 'ed0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shankar-maharaj-aarati',
                component: ComponentCreator('/shankar-maharaj-aarati', 'd6f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shankara-ashtak',
                component: ComponentCreator('/shankara-ashtak', '559'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shanta-durga',
                component: ComponentCreator('/shanta-durga', '5e2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shanti-sukta',
                component: ComponentCreator('/shanti-sukta', '549'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiv-ashtak',
                component: ComponentCreator('/shiv-ashtak', '404'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiv-chalisa',
                component: ComponentCreator('/shiv-chalisa', '123'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiv-mahimna-stotra',
                component: ComponentCreator('/shiv-mahimna-stotra', 'e20'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiv-shahtra-namavali',
                component: ComponentCreator('/shiv-shahtra-namavali', '370'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiv-stuti',
                component: ComponentCreator('/shiv-stuti', 'c9c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiv-tandav',
                component: ComponentCreator('/shiv-tandav', '86b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-aarthi-hara-stotram',
                component: ComponentCreator('/shiva-aarthi-hara-stotram', '3ae'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-abhilashaashtakam-in-hindi',
                component: ComponentCreator('/shiva-abhilashaashtakam-in-hindi', '7bb'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-agastya-ashtakam',
                component: ComponentCreator('/shiva-agastya-ashtakam', 'e2c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-anamaya-stotram',
                component: ComponentCreator('/shiva-anamaya-stotram', '9f3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-andhaka-krita-shiva-stuti',
                component: ComponentCreator('/shiva-andhaka-krita-shiva-stuti', 'f7c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-ardhanareeshwara-stotram-in-hindi',
                component: ComponentCreator('/shiva-ardhanareeshwara-stotram-in-hindi', 'f5f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-ardhanarishvara-ashtakam',
                component: ComponentCreator('/shiva-ardhanarishvara-ashtakam', 'a84'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-ardhanarishvara-ashtottara-shatanama-stotram',
                component: ComponentCreator('/shiva-ardhanarishvara-ashtottara-shatanama-stotram', 'f0f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-arunachala-ashtakam',
                component: ComponentCreator('/shiva-arunachala-ashtakam', '744'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-ashtamurti-ashtakam',
                component: ComponentCreator('/shiva-ashtamurti-ashtakam', '79c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-asitha-krutha-shiva-stotram',
                component: ComponentCreator('/shiva-asitha-krutha-shiva-stotram', '7bb'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-attala-sundara-ashtakam',
                component: ComponentCreator('/shiva-attala-sundara-ashtakam', '43d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-baneshwara-kavacha-sahita-shiva-stavaraja',
                component: ComponentCreator('/shiva-baneshwara-kavacha-sahita-shiva-stavaraja', '046'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-bilva-ashttotara-satanama-stotram-in-hindi',
                component: ComponentCreator('/shiva-bilva-ashttotara-satanama-stotram-in-hindi', '9c2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-bilvashtakam-in-hindi',
                component: ComponentCreator('/shiva-bilvashtakam-in-hindi', 'c42'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-brahmaadi-deva-krita-mahadeva-stuti',
                component: ComponentCreator('/shiva-brahmaadi-deva-krita-mahadeva-stuti', '285'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-chandrasekhara-ashtakam-in-hindi',
                component: ComponentCreator('/shiva-chandrasekhara-ashtakam-in-hindi', 'c38'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-dakshinamurthy-ashtakam',
                component: ComponentCreator('/shiva-dakshinamurthy-ashtakam', 'f8b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-daridrya-dahana-siva-stotram-in-hindi',
                component: ComponentCreator('/shiva-daridrya-dahana-siva-stotram-in-hindi', '5bb'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-dasaslokee-stuti-in-hindi',
                component: ComponentCreator('/shiva-dasaslokee-stuti-in-hindi', 'a5a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-deva-danava-krita-shiva-stotram',
                component: ComponentCreator('/shiva-deva-danava-krita-shiva-stotram', '2ab'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-deva-krita-shiva-stotram',
                component: ComponentCreator('/shiva-deva-krita-shiva-stotram', 'b4d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-deva-krita-shiva-stuti',
                component: ComponentCreator('/shiva-deva-krita-shiva-stuti', 'fc3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-devacharya-krita-shiva-stuti',
                component: ComponentCreator('/shiva-devacharya-krita-shiva-stuti', '339'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-devadaru-vanastha-muni-krita-parameshwara-stuti',
                component: ComponentCreator('/shiva-devadaru-vanastha-muni-krita-parameshwara-stuti', 'b9c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-dvadasa-jyothirlinga-stotram-in-hindi',
                component: ComponentCreator('/shiva-dvadasa-jyothirlinga-stotram-in-hindi', 'ac3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-himalaya-krita-shiva-stotram',
                component: ComponentCreator('/shiva-himalaya-krita-shiva-stotram', '15c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-indra-krita-shiva-stuti',
                component: ComponentCreator('/shiva-indra-krita-shiva-stuti', '4ce'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-ishana-stuti',
                component: ComponentCreator('/shiva-ishana-stuti', '04e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-kalki-krita-shiva-stotram',
                component: ComponentCreator('/shiva-kalki-krita-shiva-stotram', '31d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-kulasekhara-pandya-krita-sri-somasundara-stotram',
                component: ComponentCreator('/shiva-kulasekhara-pandya-krita-sri-somasundara-stotram', '2c4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-lankeshwara-krita-shiva-stuti',
                component: ComponentCreator('/shiva-lankeshwara-krita-shiva-stuti', 'f05'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-lingashtakam-in-hindi',
                component: ComponentCreator('/shiva-lingashtakam-in-hindi', '188'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-maha-mrityunjaya-mantram',
                component: ComponentCreator('/shiva-maha-mrityunjaya-mantram', '8a0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-maha-mrityunjaya-stotram-in-hindi',
                component: ComponentCreator('/shiva-maha-mrityunjaya-stotram-in-hindi', '69b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-maheshwara-pancharatna-stotram-in-hindi',
                component: ComponentCreator('/shiva-maheshwara-pancharatna-stotram-in-hindi', '3a5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-mritasanjeevani-stotram-in-hindi',
                component: ComponentCreator('/shiva-mritasanjeevani-stotram-in-hindi', '56c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-mrityunjaya-manasika-puja-stotram-in-hindi',
                component: ComponentCreator('/shiva-mrityunjaya-manasika-puja-stotram-in-hindi', '43d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-parvathi-vallabha-ashtakam',
                component: ComponentCreator('/shiva-parvathi-vallabha-ashtakam', 'c0d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-pradoshastotra-ashtakam-in-hindi',
                component: ComponentCreator('/shiva-pradoshastotra-ashtakam-in-hindi', 'e06'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-rati-devi-krita-shiva-stotram',
                component: ComponentCreator('/shiva-rati-devi-krita-shiva-stotram', 'f89'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-rudradhyaya-stuti-shatarudriyam',
                component: ComponentCreator('/shiva-rudradhyaya-stuti-shatarudriyam', '836'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-rudrashtakam-in-hindi',
                component: ComponentCreator('/shiva-rudrashtakam-in-hindi', '7ef'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sadashiva-ashtakam',
                component: ComponentCreator('/shiva-sadashiva-ashtakam', 'f1e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sanghila-krita-uma-maheswara-ashtakam',
                component: ComponentCreator('/shiva-sanghila-krita-uma-maheswara-ashtakam', '5ca'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-shiva-aparadha-kshamapana-stotram-in-hindi',
                component: ComponentCreator('/shiva-shiva-aparadha-kshamapana-stotram-in-hindi', 'eef'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-shiva-bhujanga-stotram-in-hindi',
                component: ComponentCreator('/shiva-shiva-bhujanga-stotram-in-hindi', '982'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-shiva-kesadi-padantha-varnana-stotram-in-hindi',
                component: ComponentCreator('/shiva-shiva-kesadi-padantha-varnana-stotram-in-hindi', '217'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-shiva-mahimna-stotram-in-hindi',
                component: ComponentCreator('/shiva-shiva-mahimna-stotram-in-hindi', '15b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-shiva-manasa-puja-stotram-in-hindi',
                component: ComponentCreator('/shiva-shiva-manasa-puja-stotram-in-hindi', 'c3b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-shiva-mangalashtakam-in-hindi',
                component: ComponentCreator('/shiva-shiva-mangalashtakam-in-hindi', '8dc'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-shiva-namavalyashtakam-in-hindi',
                component: ComponentCreator('/shiva-shiva-namavalyashtakam-in-hindi', '102'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-shiva-padadi-kesantha-varnana-stotram-in-hindi',
                component: ComponentCreator('/shiva-shiva-padadi-kesantha-varnana-stotram-in-hindi', '5a5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-shiva-panchakshara-nakshatramala-stotram-in-hindi',
                component: ComponentCreator('/shiva-shiva-panchakshara-nakshatramala-stotram-in-hindi', '930'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-shiva-panchakshara-stotram-in-hindi',
                component: ComponentCreator('/shiva-shiva-panchakshara-stotram-in-hindi', 'baa'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-shiva-shadakshara-stotram-in-hindi',
                component: ComponentCreator('/shiva-shiva-shadakshara-stotram-in-hindi', 'f0d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sivanandalahari-in-hindi',
                component: ComponentCreator('/shiva-sivanandalahari-in-hindi', 'd11'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sivashtakam-in-hindi',
                component: ComponentCreator('/shiva-sivashtakam-in-hindi', '094'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-batuka-bhairava-ashtottara-shatanamavali',
                component: ComponentCreator('/shiva-sri-batuka-bhairava-ashtottara-shatanamavali', 'bd1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-chandramouleshwara-stava',
                component: ComponentCreator('/shiva-sri-chandramouleshwara-stava', 'edd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-chandramouleshwara-stotram',
                component: ComponentCreator('/shiva-sri-chandramouleshwara-stotram', '18a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-chandramoulishwara-varnamala-stotram',
                component: ComponentCreator('/shiva-sri-chandramoulishwara-varnamala-stotram', 'e2b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-chidambara-ashtakam',
                component: ComponentCreator('/shiva-sri-chidambara-ashtakam', 'a67'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-chidambara-panchachamara-stotram',
                component: ComponentCreator('/shiva-sri-chidambara-panchachamara-stotram', 'e5c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-chidambareshwara-stotram',
                component: ComponentCreator('/shiva-sri-chidambareshwara-stotram', '436'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-dakshinamurthy-pancharatna-stotram',
                component: ComponentCreator('/shiva-sri-dakshinamurthy-pancharatna-stotram', '4cc'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-dakshinamurthy-stotram-4',
                component: ComponentCreator('/shiva-sri-dakshinamurthy-stotram-4', 'e74'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-gangadhara-stotram',
                component: ComponentCreator('/shiva-sri-gangadhara-stotram', '2a2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-halasyesha-ashtakam',
                component: ComponentCreator('/shiva-sri-halasyesha-ashtakam', 'e84'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-harihara-ashtottara-shatanama-stotram-in-hindi',
                component: ComponentCreator('/shiva-sri-harihara-ashtottara-shatanama-stotram-in-hindi', '881'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-hatakeshwara-ashtakam',
                component: ComponentCreator('/shiva-sri-hatakeshwara-ashtakam', '2a1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-hatakeshwara-stuti',
                component: ComponentCreator('/shiva-sri-hatakeshwara-stuti', '183'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-kashi-vishwanatha-ashtottara-shatanama-stotram',
                component: ComponentCreator('/shiva-sri-kashi-vishwanatha-ashtottara-shatanama-stotram', '05b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-krishna-krita-sri-shiva-stotram',
                component: ComponentCreator('/shiva-sri-krishna-krita-sri-shiva-stotram', 'a9e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-mahadeva-stotram-in-hindi',
                component: ComponentCreator('/shiva-sri-mahadeva-stotram-in-hindi', '24b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-margabandhu-stotram-in-hindi',
                component: ComponentCreator('/shiva-sri-margabandhu-stotram-in-hindi', 'bc4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-medha-dakshinamurthy-mantra',
                component: ComponentCreator('/shiva-sri-medha-dakshinamurthy-mantra', 'd98'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-medha-dakshinamurthy-stotram',
                component: ComponentCreator('/shiva-sri-medha-dakshinamurthy-stotram', '33f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-mrityunjaya-aksharamala-stotram',
                component: ComponentCreator('/shiva-sri-mrityunjaya-aksharamala-stotram', '77c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-mrityunjaya-stotram',
                component: ComponentCreator('/shiva-sri-mrityunjaya-stotram', '2e7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-nataraja-ashtakam',
                component: ComponentCreator('/shiva-sri-nataraja-ashtakam', '70d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-nataraja-stotram-patanjali-krutam',
                component: ComponentCreator('/shiva-sri-nataraja-stotram-patanjali-krutam', '203'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-natesha-stava',
                component: ComponentCreator('/shiva-sri-natesha-stava', 'b51'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-nateshwara-bhujanga-stuti',
                component: ComponentCreator('/shiva-sri-nateshwara-bhujanga-stuti', '683'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-pashupathi-ashtakam-in-hindi',
                component: ComponentCreator('/shiva-sri-pashupathi-ashtakam-in-hindi', '40e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-rudra-kavacham-in-hindi',
                component: ComponentCreator('/shiva-sri-rudra-kavacham-in-hindi', '598'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-rudra-stavanam',
                component: ComponentCreator('/shiva-sri-rudra-stavanam', '633'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-rudra-stuti-in-hindi',
                component: ComponentCreator('/shiva-sri-rudra-stuti-in-hindi', 'bbd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-samba-sada-shiva-aksharamala-stotram-in-hindi',
                component: ComponentCreator('/shiva-sri-samba-sada-shiva-aksharamala-stotram-in-hindi', 'f53'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-samba-sada-shiva-bhujanga-prayata-stotram-in-hindi',
                component: ComponentCreator('/shiva-sri-samba-sada-shiva-bhujanga-prayata-stotram-in-hindi', 'a70'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-shankara-ashtakam',
                component: ComponentCreator('/shiva-sri-shankara-ashtakam', '5e8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-sharva-stuti-krishna-arjuna-krutam',
                component: ComponentCreator('/shiva-sri-sharva-stuti-krishna-arjuna-krutam', '7ba'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-shiva-ashtakam-2',
                component: ComponentCreator('/shiva-sri-shiva-ashtakam-2', 'f75'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-shiva-ashtakam-3-shankaracharya-kritam',
                component: ComponentCreator('/shiva-sri-shiva-ashtakam-3-shankaracharya-kritam', '38e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-shiva-ashtottara-satanama-stotra-in-hindi',
                component: ComponentCreator('/shiva-sri-shiva-ashtottara-satanama-stotra-in-hindi', 'df0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-shiva-dhyana-mantra',
                component: ComponentCreator('/shiva-sri-shiva-dhyana-mantra', '9ba'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-shiva-dvadasha-nama-stotram-in-hindi',
                component: ComponentCreator('/shiva-sri-shiva-dvadasha-nama-stotram-in-hindi', 'b54'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-shiva-gadyam-shivapadana-dandaka-stotram',
                component: ComponentCreator('/shiva-sri-shiva-gadyam-shivapadana-dandaka-stotram', 'c8a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-shiva-hrudayam',
                component: ComponentCreator('/shiva-sri-shiva-hrudayam', '130'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-shiva-manasika-puja-stotram',
                component: ComponentCreator('/shiva-sri-shiva-manasika-puja-stotram', '463'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-shiva-navaratna-stava',
                component: ComponentCreator('/shiva-sri-shiva-navaratna-stava', '078'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-shiva-panchakshari-mantra-nyasa-sahitam',
                component: ComponentCreator('/shiva-sri-shiva-panchakshari-mantra-nyasa-sahitam', '509'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-shiva-pancharatna-stuti-krishna-kritam',
                component: ComponentCreator('/shiva-sri-shiva-pancharatna-stuti-krishna-kritam', 'fd5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-shiva-pratipadana-stotram',
                component: ComponentCreator('/shiva-sri-shiva-pratipadana-stotram', 'fa8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-shiva-raksha-stotram-in-hindi',
                component: ComponentCreator('/shiva-sri-shiva-raksha-stotram-in-hindi', '0f9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-shiva-sahasranama-stotram-in-hindi',
                component: ComponentCreator('/shiva-sri-shiva-sahasranama-stotram-in-hindi', 'c6b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-shiva-sahasranama-stotram-poorva-peetika-in-hindi',
                component: ComponentCreator('/shiva-sri-shiva-sahasranama-stotram-poorva-peetika-in-hindi', '964'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-shiva-shankara-stotram',
                component: ComponentCreator('/shiva-sri-shiva-shankara-stotram', 'd5b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-shiva-stuti',
                component: ComponentCreator('/shiva-sri-shiva-stuti', 'd0b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-shiva-stuti-vande-shambhum-umapathim',
                component: ComponentCreator('/shiva-sri-shiva-stuti-vande-shambhum-umapathim', '8db'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-siva-kavacham-in-hindi',
                component: ComponentCreator('/shiva-sri-siva-kavacham-in-hindi', '1eb'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-sri-somasundara-ashtakam',
                component: ComponentCreator('/shiva-sri-somasundara-ashtakam', '564'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-suvarnamala-stuti-in-hindi',
                component: ComponentCreator('/shiva-suvarnamala-stuti-in-hindi', 'e07'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-uma-maheshwara-stotram-in-hindi',
                component: ComponentCreator('/shiva-uma-maheshwara-stotram-in-hindi', '98f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-upamanyu-krutha-shiva-stotram',
                component: ComponentCreator('/shiva-upamanyu-krutha-shiva-stotram', '975'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-varuna-krita-shiva-stotram',
                component: ComponentCreator('/shiva-varuna-krita-shiva-stotram', '9d8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-vasishta-krita-parameshwara-stuti',
                component: ComponentCreator('/shiva-vasishta-krita-parameshwara-stuti', '209'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-vedasara-siva-stotram-in-hindi',
                component: ComponentCreator('/shiva-vedasara-siva-stotram-in-hindi', '668'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-vishwanatha-ashtakam-in-hindi',
                component: ComponentCreator('/shiva-vishwanatha-ashtakam-in-hindi', 'a3a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-vyasa-krita-dakshinamurthy-ashtakam',
                component: ComponentCreator('/shiva-vyasa-krita-dakshinamurthy-ashtakam', 'ca3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shiva-yama-kruta-shiva-keshava-stuti',
                component: ComponentCreator('/shiva-yama-kruta-shiva-keshava-stuti', '09a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shivamuth-kahani',
                component: ComponentCreator('/shivamuth-kahani', '98e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shivlilamrut-adhyay-1',
                component: ComponentCreator('/shivlilamrut-adhyay-1', '4ce'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shivlilamrut-adhyay-10',
                component: ComponentCreator('/shivlilamrut-adhyay-10', 'cc8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shivlilamrut-adhyay-11',
                component: ComponentCreator('/shivlilamrut-adhyay-11', '5f3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shivlilamrut-adhyay-12',
                component: ComponentCreator('/shivlilamrut-adhyay-12', '9a6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shivlilamrut-adhyay-13',
                component: ComponentCreator('/shivlilamrut-adhyay-13', '0a3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shivlilamrut-adhyay-14',
                component: ComponentCreator('/shivlilamrut-adhyay-14', '99a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shivlilamrut-adhyay-15',
                component: ComponentCreator('/shivlilamrut-adhyay-15', '857'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shivlilamrut-adhyay-2',
                component: ComponentCreator('/shivlilamrut-adhyay-2', '9b5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shivlilamrut-adhyay-3',
                component: ComponentCreator('/shivlilamrut-adhyay-3', '75e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shivlilamrut-adhyay-4',
                component: ComponentCreator('/shivlilamrut-adhyay-4', '17b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shivlilamrut-adhyay-5',
                component: ComponentCreator('/shivlilamrut-adhyay-5', '46c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shivlilamrut-adhyay-6',
                component: ComponentCreator('/shivlilamrut-adhyay-6', 'b0d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shivlilamrut-adhyay-7',
                component: ComponentCreator('/shivlilamrut-adhyay-7', 'f6a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shivlilamrut-adhyay-8',
                component: ComponentCreator('/shivlilamrut-adhyay-8', '8d6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shivlilamrut-adhyay-9',
                component: ComponentCreator('/shivlilamrut-adhyay-9', 'd45'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shivpuja',
                component: ComponentCreator('/shivpuja', '23d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shravani-somvar-katha',
                component: ComponentCreator('/shravani-somvar-katha', '04e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shri-bala-tripursundari-namavali',
                component: ComponentCreator('/shri-bala-tripursundari-namavali', '85b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shri-datta-namavali',
                component: ComponentCreator('/shri-datta-namavali', '699'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shri-durga-namavali',
                component: ComponentCreator('/shri-durga-namavali', 'b95'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shri-ganesh-namavali',
                component: ComponentCreator('/shri-ganesh-namavali', 'f1a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shri-guru-charitra-aarati',
                component: ComponentCreator('/shri-guru-charitra-aarati', '955'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shri-jivatichi aarati',
                component: ComponentCreator('/shri-jivatichi aarati', '989'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shri-kamala-namavali',
                component: ComponentCreator('/shri-kamala-namavali', 'fa4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shri-lalita-sasranamavali',
                component: ComponentCreator('/shri-lalita-sasranamavali', 'c6a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shri-ram-namavali',
                component: ComponentCreator('/shri-ram-namavali', '776'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shri-saptshati-durga-stotra',
                component: ComponentCreator('/shri-saptshati-durga-stotra', '445'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shri-shivaji-maharaj-aarati',
                component: ComponentCreator('/shri-shivaji-maharaj-aarati', '80e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shri-siddhnath-aarati',
                component: ComponentCreator('/shri-siddhnath-aarati', 'b1f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shri-sukta',
                component: ComponentCreator('/shri-sukta', 'ae5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shri-vasudevanand-sarswati-maharaj-aarati',
                component: ComponentCreator('/shri-vasudevanand-sarswati-maharaj-aarati', '5ad'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shri-vishnu-suktm',
                component: ComponentCreator('/shri-vishnu-suktm', 'cc8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shri-yadyavalkya-namavali',
                component: ComponentCreator('/shri-yadyavalkya-namavali', '382'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shriram',
                component: ComponentCreator('/shriram', '56d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shriram-dhava-stotra',
                component: ComponentCreator('/shriram-dhava-stotra', '713'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shriram-stuti',
                component: ComponentCreator('/shriram-stuti', 'b00'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/shubham-karoti',
                component: ComponentCreator('/shubham-karoti', '899'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/siddhamangal-stotra',
                component: ComponentCreator('/siddhamangal-stotra', 'ee2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/sola-somvar',
                component: ComponentCreator('/sola-somvar', '0c9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/somvar-fasaki-kahani',
                component: ComponentCreator('/somvar-fasaki-kahani', '17a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/somvar-kahani',
                component: ComponentCreator('/somvar-kahani', 'a70'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/somvati-kahani',
                component: ComponentCreator('/somvati-kahani', '77b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/stri-garwar',
                component: ComponentCreator('/stri-garwar', 'a8a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-guha-pancharatnam',
                component: ComponentCreator('/subrahmanya-guha-pancharatnam', 'd5c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-jaya-skanda-stotram',
                component: ComponentCreator('/subrahmanya-jaya-skanda-stotram', 'e1e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-saravana-bhava-devasenesha-shatkam',
                component: ComponentCreator('/subrahmanya-saravana-bhava-devasenesha-shatkam', '37b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-saravanabhava-mantrakshara-shatkam',
                component: ComponentCreator('/subrahmanya-saravanabhava-mantrakshara-shatkam', 'e52'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-shadanana-ashtakam',
                component: ComponentCreator('/subrahmanya-shadanana-ashtakam', '81b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-shadanana-stuti',
                component: ComponentCreator('/subrahmanya-shadanana-stuti', '902'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-skanda-sashti-kavacham',
                component: ComponentCreator('/subrahmanya-skanda-sashti-kavacham', '4e2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-skanda-veda-pada-stava',
                component: ComponentCreator('/subrahmanya-skanda-veda-pada-stava', '9f5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-sri-dandapani-pancharatnam',
                component: ComponentCreator('/subrahmanya-sri-dandapani-pancharatnam', '736'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-sri-dandayudhapani-ashtakam',
                component: ComponentCreator('/subrahmanya-sri-dandayudhapani-ashtakam', 'ade'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-sri-karthikeya-ashtakam',
                component: ComponentCreator('/subrahmanya-sri-karthikeya-ashtakam', '73c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-sri-karthikeya-karavalamba-stotram',
                component: ComponentCreator('/subrahmanya-sri-karthikeya-karavalamba-stotram', 'bf8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-sri-karthikeya-stotram',
                component: ComponentCreator('/subrahmanya-sri-karthikeya-stotram', 'a67'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-sri-kumara-kavacham',
                component: ComponentCreator('/subrahmanya-sri-kumara-kavacham', '095'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-sri-kumara-stuti',
                component: ComponentCreator('/subrahmanya-sri-kumara-stuti', '442'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-sri-kumara-stuti-deva-krutam',
                component: ComponentCreator('/subrahmanya-sri-kumara-stuti-deva-krutam', '1fc'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-sri-pragnya-vivardhana-karthikeya-stotram-in-hindi',
                component: ComponentCreator('/subrahmanya-sri-pragnya-vivardhana-karthikeya-stotram-in-hindi', '131'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-sri-shanmukha-bhujanga-stuti',
                component: ComponentCreator('/subrahmanya-sri-shanmukha-bhujanga-stuti', 'a69'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-sri-shanmukha-dandakam',
                component: ComponentCreator('/subrahmanya-sri-shanmukha-dandakam', '4b4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-sri-shanmukha-pancharatna-stuti',
                component: ComponentCreator('/subrahmanya-sri-shanmukha-pancharatna-stuti', '4a0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-sri-shanmukha-shatkam',
                component: ComponentCreator('/subrahmanya-sri-shanmukha-shatkam', '8cb'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-sri-shanmukha-shatpadi-stava',
                component: ComponentCreator('/subrahmanya-sri-shanmukha-shatpadi-stava', 'e03'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-sri-shanmukha-stotram',
                component: ComponentCreator('/subrahmanya-sri-shanmukha-stotram', '073'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-sri-skanda-dandakam',
                component: ComponentCreator('/subrahmanya-sri-skanda-dandakam', '2ca'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-sri-skanda-lahari-in-hindi',
                component: ComponentCreator('/subrahmanya-sri-skanda-lahari-in-hindi', '17f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-sri-skanda-shatkam',
                component: ComponentCreator('/subrahmanya-sri-skanda-shatkam', 'a63'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-sri-skanda-stavam',
                component: ComponentCreator('/subrahmanya-sri-skanda-stavam', '94e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-sri-skanda-stotram-mahabharatam',
                component: ComponentCreator('/subrahmanya-sri-skanda-stotram-mahabharatam', 'ba8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-sri-subrahmanya-aparadha-kshamapana-stotram',
                component: ComponentCreator('/subrahmanya-sri-subrahmanya-aparadha-kshamapana-stotram', 'f3b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-sri-subrahmanya-ashtottara-satanama-stotram',
                component: ComponentCreator('/subrahmanya-sri-subrahmanya-ashtottara-satanama-stotram', '374'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-sri-subrahmanya-bhujanga-prayata-stotram',
                component: ComponentCreator('/subrahmanya-sri-subrahmanya-bhujanga-prayata-stotram', '879'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-sri-subrahmanya-bhujanga-prayata-stotram-2',
                component: ComponentCreator('/subrahmanya-sri-subrahmanya-bhujanga-prayata-stotram-2', '5fd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-sri-subrahmanya-dandakam',
                component: ComponentCreator('/subrahmanya-sri-subrahmanya-dandakam', 'ae1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-sri-subrahmanya-gadyam',
                component: ComponentCreator('/subrahmanya-sri-subrahmanya-gadyam', '61d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-sri-subrahmanya-hrudaya-stotram',
                component: ComponentCreator('/subrahmanya-sri-subrahmanya-hrudaya-stotram', 'ad1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-sri-subrahmanya-kavacha-stotram-in-hindi',
                component: ComponentCreator('/subrahmanya-sri-subrahmanya-kavacha-stotram-in-hindi', 'de7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-sri-subrahmanya-mala-mantra',
                component: ComponentCreator('/subrahmanya-sri-subrahmanya-mala-mantra', '271'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-sri-subrahmanya-manasa-puja-stotram',
                component: ComponentCreator('/subrahmanya-sri-subrahmanya-manasa-puja-stotram', 'eb3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-sri-subrahmanya-mangala-ashtakam',
                component: ComponentCreator('/subrahmanya-sri-subrahmanya-mangala-ashtakam', '8dd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-sri-subrahmanya-sahasranama-stotram',
                component: ComponentCreator('/subrahmanya-sri-subrahmanya-sahasranama-stotram', '04b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-sri-subrahmanya-sharanagati-gadyam',
                component: ComponentCreator('/subrahmanya-sri-subrahmanya-sharanagati-gadyam', 'f7c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-sri-subrahmanya-shatkam',
                component: ComponentCreator('/subrahmanya-sri-subrahmanya-shatkam', '951'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-sri-subrahmanya-shodasa-nama-stotram-in-hindi',
                component: ComponentCreator('/subrahmanya-sri-subrahmanya-shodasa-nama-stotram-in-hindi', '4c4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-sri-subrahmanya-stotram-in-hindi',
                component: ComponentCreator('/subrahmanya-sri-subrahmanya-stotram-in-hindi', '880'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-sri-subrahmanya-vajra-panjara-kavacham',
                component: ComponentCreator('/subrahmanya-sri-subrahmanya-vajra-panjara-kavacham', '3ac'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-sri-subrahmaya-aksharamalika-stotram',
                component: ComponentCreator('/subrahmanya-sri-subrahmaya-aksharamalika-stotram', 'e02'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-sri-subramanya-moola-mantra-stava',
                component: ComponentCreator('/subrahmanya-sri-subramanya-moola-mantra-stava', '76c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-subrahmanya-ashtakam',
                component: ComponentCreator('/subrahmanya-subrahmanya-ashtakam', '273'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-subrahmanya-bhujanga-stotram-in-hindi',
                component: ComponentCreator('/subrahmanya-subrahmanya-bhujanga-stotram-in-hindi', '812'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-subrahmanya-pancharatnam-in-hindi',
                component: ComponentCreator('/subrahmanya-subrahmanya-pancharatnam-in-hindi', 'a99'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/subrahmanya-subrahmanya-shadakshara-ashtottara-shatanama-stotram',
                component: ComponentCreator('/subrahmanya-subrahmanya-shadakshara-ashtottara-shatanama-stotram', '776'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/surya',
                component: ComponentCreator('/surya', '494'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/suryadev-chalisa',
                component: ComponentCreator('/suryadev-chalisa', '851'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/swami-charitra-saramrut-adhyay-1',
                component: ComponentCreator('/swami-charitra-saramrut-adhyay-1', 'da9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/swami-charitra-saramrut-adhyay-10',
                component: ComponentCreator('/swami-charitra-saramrut-adhyay-10', '6f9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/swami-charitra-saramrut-adhyay-11',
                component: ComponentCreator('/swami-charitra-saramrut-adhyay-11', '359'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/swami-charitra-saramrut-adhyay-12',
                component: ComponentCreator('/swami-charitra-saramrut-adhyay-12', 'd71'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/swami-charitra-saramrut-adhyay-13',
                component: ComponentCreator('/swami-charitra-saramrut-adhyay-13', 'd4b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/swami-charitra-saramrut-adhyay-14',
                component: ComponentCreator('/swami-charitra-saramrut-adhyay-14', 'd58'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/swami-charitra-saramrut-adhyay-15',
                component: ComponentCreator('/swami-charitra-saramrut-adhyay-15', 'aa7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/swami-charitra-saramrut-adhyay-16',
                component: ComponentCreator('/swami-charitra-saramrut-adhyay-16', 'bfb'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/swami-charitra-saramrut-adhyay-17',
                component: ComponentCreator('/swami-charitra-saramrut-adhyay-17', '173'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/swami-charitra-saramrut-adhyay-18',
                component: ComponentCreator('/swami-charitra-saramrut-adhyay-18', '4ef'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/swami-charitra-saramrut-adhyay-19',
                component: ComponentCreator('/swami-charitra-saramrut-adhyay-19', 'd6d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/swami-charitra-saramrut-adhyay-2',
                component: ComponentCreator('/swami-charitra-saramrut-adhyay-2', '9a4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/swami-charitra-saramrut-adhyay-20',
                component: ComponentCreator('/swami-charitra-saramrut-adhyay-20', 'fa7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/swami-charitra-saramrut-adhyay-21',
                component: ComponentCreator('/swami-charitra-saramrut-adhyay-21', '8ef'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/swami-charitra-saramrut-adhyay-3',
                component: ComponentCreator('/swami-charitra-saramrut-adhyay-3', 'ba6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/swami-charitra-saramrut-adhyay-4',
                component: ComponentCreator('/swami-charitra-saramrut-adhyay-4', 'a72'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/swami-charitra-saramrut-adhyay-5',
                component: ComponentCreator('/swami-charitra-saramrut-adhyay-5', 'dd8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/swami-charitra-saramrut-adhyay-6',
                component: ComponentCreator('/swami-charitra-saramrut-adhyay-6', '1ef'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/swami-charitra-saramrut-adhyay-7',
                component: ComponentCreator('/swami-charitra-saramrut-adhyay-7', '8f6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/swami-charitra-saramrut-adhyay-8',
                component: ComponentCreator('/swami-charitra-saramrut-adhyay-8', '8d1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/swami-charitra-saramrut-adhyay-9',
                component: ComponentCreator('/swami-charitra-saramrut-adhyay-9', '7b6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/swami-samarth-maharaj',
                component: ComponentCreator('/swami-samarth-maharaj', '996'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/swami-samarth-taarak-mantra',
                component: ComponentCreator('/swami-samarth-taarak-mantra', 'c1a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/swarnakarshan-bhaiarav-stuti',
                component: ComponentCreator('/swarnakarshan-bhaiarav-stuti', '175'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/swati-shri',
                component: ComponentCreator('/swati-shri', 'fb0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/tantroktam-devi-suktm',
                component: ComponentCreator('/tantroktam-devi-suktm', 'f71'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/tembe-maharaj-aarati',
                component: ComponentCreator('/tembe-maharaj-aarati', 'cae'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/tirth-vitthal',
                component: ComponentCreator('/tirth-vitthal', 'f03'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/tribhuvan-palana',
                component: ComponentCreator('/tribhuvan-palana', '4f0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/tulasi-vivah',
                component: ComponentCreator('/tulasi-vivah', '172'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/vaidyanath-ashtak',
                component: ComponentCreator('/vaidyanath-ashtak', '474'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-1',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-1', '86d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-10',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-10', '092'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-11',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-11', 'bda'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-12',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-12', 'bb9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-13',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-13', '1e1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-14',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-14', '984'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-15',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-15', '526'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-16',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-16', '934'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-17',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-17', '002'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-18',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-18', '88f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-19',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-19', '9d8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-2',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-2', '60d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-20',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-20', '6bd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-21',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-21', 'bbf'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-22',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-22', '901'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-23',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-23', '4d1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-24',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-24', 'd05'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-25',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-25', 'b54'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-26',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-26', '539'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-27',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-27', '084'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-28',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-28', '6eb'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-29',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-29', '3d0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-3',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-3', '5b1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-30',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-30', 'f6d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-31',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-31', '2ef'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-32',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-32', '4fa'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-33',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-33', 'b8c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-34',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-34', '42a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-35',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-35', '7e4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-36',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-36', '1d5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-37',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-37', '33e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-38',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-38', 'e60'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-39',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-39', 'ef2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-4',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-4', '1a1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-40',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-40', 'f26'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-41',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-41', '3e6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-42',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-42', '8a3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-43',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-43', '510'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-44',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-44', '941'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-45',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-45', '8bb'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-46',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-46', '029'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-47',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-47', '0fd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-48',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-48', '8cf'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-49',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-49', '6ce'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-5',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-5', 'cc1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-50',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-50', '8ed'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-51',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-51', 'cb3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-52',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-52', '221'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-53',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-53', '42b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-54',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-54', '052'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-55',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-55', '3fb'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-56',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-56', '12c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-57',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-57', 'efe'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-58',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-58', '0a6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-59',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-59', '396'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-6',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-6', 'cb7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-60',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-60', '906'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-61',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-61', 'cef'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-62',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-62', '329'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-63',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-63', '1e6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-64',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-64', 'abf'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-65',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-65', 'b43'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-66',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-66', '3c2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-67',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-67', '1b4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-68',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-68', 'adc'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-69',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-69', '0a3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-7',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-7', '706'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-70',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-70', '85e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-71',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-71', '077'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-72',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-72', '794'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-73',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-73', 'ffc'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-74',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-74', '030'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-75',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-75', 'ae1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-8',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-8', 'a06'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-aranyakand-adhyay-9',
                component: ComponentCreator('/valmiki-ramayan-aranyakand-adhyay-9', 'd2d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-1',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-1', '0d9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-10',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-10', '208'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-100',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-100', '9a6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-101',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-101', '5a8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-102',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-102', 'ca2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-103',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-103', 'f95'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-104',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-104', 'd44'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-105',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-105', '05e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-106',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-106', 'ce1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-107',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-107', 'bb9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-108',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-108', '976'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-109',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-109', '856'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-11',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-11', '815'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-110',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-110', '129'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-111',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-111', '862'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-112',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-112', '037'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-113',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-113', 'f0d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-114',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-114', '332'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-115',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-115', 'bfb'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-116',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-116', 'f39'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-117',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-117', 'ecc'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-118',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-118', '4b1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-119',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-119', '180'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-12',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-12', 'ab7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-13',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-13', 'b2c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-14',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-14', 'eb7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-15',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-15', '064'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-16',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-16', '785'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-17',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-17', 'f68'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-18',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-18', '4b1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-19',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-19', 'bf6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-2',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-2', 'c9f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-20',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-20', 'cf7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-21',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-21', '246'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-22',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-22', '1dc'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-23',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-23', '5c2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-24',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-24', '94e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-25',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-25', '42e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-26',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-26', '2e0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-27',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-27', 'f19'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-28',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-28', 'cdb'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-29',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-29', '7e8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-3',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-3', '75e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-30',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-30', '304'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-31',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-31', '4be'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-32',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-32', '93f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-33',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-33', '1d2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-34',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-34', 'a3d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-35',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-35', 'b94'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-36',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-36', '9f4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-37',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-37', 'e34'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-38',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-38', '36f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-39',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-39', 'd12'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-4',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-4', 'd77'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-40',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-40', '9c9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-41',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-41', '135'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-42',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-42', '162'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-43',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-43', '92b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-44',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-44', '688'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-45',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-45', '683'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-46',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-46', '324'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-47',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-47', '943'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-48',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-48', 'e0c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-49',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-49', 'e5a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-5',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-5', '924'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-50',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-50', '61b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-51',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-51', '2bc'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-52',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-52', '68e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-53',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-53', '62b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-54',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-54', '7b9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-55',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-55', '09c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-56',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-56', 'fd0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-57',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-57', 'd32'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-58',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-58', '786'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-59',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-59', '0eb'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-6',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-6', '358'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-60',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-60', '408'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-61',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-61', '8e2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-62',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-62', '5e9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-63',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-63', '5e9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-64',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-64', '4d1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-65',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-65', '756'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-66',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-66', 'f16'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-67',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-67', '322'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-68',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-68', '345'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-69',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-69', 'e05'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-7',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-7', '4d0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-70',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-70', '96f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-71',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-71', 'f51'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-72',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-72', '946'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-73',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-73', 'd25'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-74',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-74', '166'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-75',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-75', '3cd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-76',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-76', '422'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-77',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-77', '53e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-78',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-78', 'b6b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-79',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-79', 'bd8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-8',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-8', 'd5d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-80',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-80', '2dd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-81',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-81', '257'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-82',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-82', 'e79'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-83',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-83', '132'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-84',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-84', '5ae'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-85',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-85', '8a1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-86',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-86', '63c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-87',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-87', 'c7a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-88',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-88', '877'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-89',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-89', 'cc9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-9',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-9', 'ffb'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-90',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-90', 'ca1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-91',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-91', 'ab1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-92',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-92', '3f1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-93',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-93', '525'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-94',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-94', '9de'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-95',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-95', 'c1a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-96',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-96', 'f9a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-97',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-97', 'e87'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-98',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-98', '655'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-ayodhyakand-adhyay-99',
                component: ComponentCreator('/valmiki-ramayan-ayodhyakand-adhyay-99', 'eed'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-1',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-1', 'b03'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-10',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-10', '0ba'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-11',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-11', 'b05'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-12',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-12', '373'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-13',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-13', '882'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-14',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-14', 'afd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-15',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-15', '692'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-16',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-16', '384'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-17',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-17', '0ae'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-18',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-18', 'c2f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-19',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-19', '7ea'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-2',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-2', '39e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-20',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-20', '949'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-21',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-21', '8f0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-22',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-22', '6f3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-23',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-23', '881'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-24',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-24', '9df'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-25',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-25', '180'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-26',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-26', 'c5a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-27',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-27', '489'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-28',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-28', '553'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-29',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-29', '257'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-3',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-3', 'a5c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-30',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-30', '497'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-31',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-31', 'c22'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-32',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-32', 'ab7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-33',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-33', 'd20'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-34',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-34', '5a9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-35',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-35', '323'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-36',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-36', '90a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-37',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-37', 'c2e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-38',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-38', '086'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-39',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-39', 'cee'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-4',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-4', '918'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-40',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-40', '24c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-41',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-41', '6da'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-42',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-42', 'cf9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-43',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-43', 'be9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-44',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-44', '10d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-45',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-45', '7e4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-46',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-46', 'f44'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-47',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-47', 'b4f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-48',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-48', 'e36'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-49',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-49', '7ef'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-5',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-5', 'c84'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-50',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-50', '985'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-51',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-51', '8f0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-52',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-52', '8f1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-53',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-53', 'f5a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-54',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-54', '0a7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-55',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-55', 'e05'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-56',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-56', 'ca2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-57',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-57', '11d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-58',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-58', '76e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-59',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-59', '454'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-6',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-6', '546'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-60',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-60', 'c37'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-61',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-61', '252'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-62',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-62', '369'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-63',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-63', 'bfe'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-64',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-64', '29d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-65',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-65', 'a07'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-66',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-66', '524'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-67',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-67', '960'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-68',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-68', '966'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-69',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-69', '256'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-7',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-7', 'eb9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-70',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-70', 'f1b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-71',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-71', '086'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-72',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-72', 'b25'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-73',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-73', '20b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-74',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-74', 'b5d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-75',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-75', 'fd7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-76',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-76', '510'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-77',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-77', '033'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-8',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-8', 'c50'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-balakand-adhyay-9',
                component: ComponentCreator('/valmiki-ramayan-balakand-adhyay-9', '5c9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-1',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-1', 'cb2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-10',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-10', '5bc'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-11',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-11', 'f1c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-12',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-12', '595'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-13',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-13', '6a1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-14',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-14', 'c35'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-15',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-15', 'e25'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-16',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-16', '522'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-17',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-17', '518'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-18',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-18', '914'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-19',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-19', 'a66'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-2',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-2', '6b4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-20',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-20', '2a5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-21',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-21', 'd7b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-22',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-22', '9f7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-23',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-23', 'fca'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-24',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-24', '595'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-25',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-25', 'd11'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-26',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-26', '1ff'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-27',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-27', 'dbb'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-28',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-28', '7e9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-29',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-29', 'c6f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-3',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-3', 'c29'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-30',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-30', '9be'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-31',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-31', '90c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-32',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-32', '620'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-33',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-33', '12b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-34',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-34', '049'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-35',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-35', 'c1c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-36',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-36', '82c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-37',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-37', 'ba6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-38',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-38', '54d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-39',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-39', 'd06'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-4',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-4', '2bf'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-40',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-40', '919'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-41',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-41', 'a50'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-42',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-42', '563'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-43',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-43', 'e28'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-44',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-44', '14a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-45',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-45', 'd1f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-46',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-46', 'cc3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-47',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-47', '1fa'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-48',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-48', '4e7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-49',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-49', '335'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-5',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-5', 'fbd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-50',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-50', 'dcb'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-51',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-51', '57f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-52',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-52', '372'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-53',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-53', 'eca'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-54',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-54', 'ecd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-55',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-55', 'd8a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-56',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-56', '775'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-57',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-57', 'dbf'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-58',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-58', '3fe'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-59',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-59', '62e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-6',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-6', '30c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-60',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-60', '084'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-61',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-61', 'e21'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-62',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-62', 'd9b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-63',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-63', '376'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-64',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-64', '4b8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-65',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-65', 'b49'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-66',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-66', '5b5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-67',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-67', '85e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-7',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-7', '822'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-8',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-8', 'ccc'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-kishkindhakand-adhyay-9',
                component: ComponentCreator('/valmiki-ramayan-kishkindhakand-adhyay-9', 'f05'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-1',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-1', '4dd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-10',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-10', '965'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-11',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-11', '996'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-12',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-12', '8f7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-13',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-13', '406'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-14',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-14', '34d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-15',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-15', '4d7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-16',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-16', '0b1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-17',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-17', '869'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-18',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-18', '245'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-19',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-19', 'dba'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-2',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-2', '00c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-20',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-20', '808'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-21',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-21', 'a30'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-22',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-22', '8ee'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-23',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-23', 'cdd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-24',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-24', '07a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-25',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-25', '107'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-26',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-26', 'b23'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-27',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-27', '16c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-28',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-28', 'f08'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-29',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-29', '78b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-3',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-3', '7f4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-30',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-30', '0d8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-31',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-31', '94b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-32',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-32', '74c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-33',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-33', '379'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-34',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-34', '224'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-35',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-35', '655'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-36',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-36', '68e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-37',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-37', 'ae7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-38',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-38', '942'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-39',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-39', 'f72'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-4',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-4', '110'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-40',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-40', '5f9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-41',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-41', '533'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-42',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-42', '2f5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-43',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-43', '720'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-44',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-44', 'ced'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-45',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-45', '6be'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-46',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-46', 'e5d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-47',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-47', '1d4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-48',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-48', '216'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-49',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-49', '281'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-5',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-5', '4e9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-50',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-50', '23f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-51',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-51', '026'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-52',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-52', '204'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-53',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-53', 'fba'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-54',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-54', '515'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-55',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-55', '81a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-56',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-56', 'b20'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-57',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-57', '3ed'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-58',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-58', '2d6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-59',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-59', '81c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-6',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-6', '44a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-60',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-60', '90a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-61',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-61', '04f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-62',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-62', '1e2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-63',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-63', '2aa'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-64',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-64', 'ece'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-65',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-65', 'c63'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-66',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-66', '289'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-67',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-67', 'a73'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-68',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-68', 'a56'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-7',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-7', '358'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-8',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-8', '3c0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-sundarakand-adhyay-9',
                component: ComponentCreator('/valmiki-ramayan-sundarakand-adhyay-9', 'c7d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-1',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-1', '559'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-10',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-10', '3fd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-100',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-100', '3b5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-101',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-101', '063'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-102',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-102', '798'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-103',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-103', 'ae7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-104',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-104', '526'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-105',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-105', 'fa5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-106',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-106', '08b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-107',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-107', '324'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-108',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-108', '319'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-109',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-109', 'd67'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-11',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-11', '101'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-110',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-110', 'c20'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-111',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-111', '95d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-112',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-112', 'e9c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-113',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-113', '308'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-114',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-114', '1aa'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-115',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-115', '238'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-116',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-116', 'd11'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-117',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-117', 'cf7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-118',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-118', 'f9b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-119',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-119', '9a7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-12',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-12', '1e3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-120',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-120', 'c11'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-121',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-121', '736'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-122',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-122', '2d6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-123',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-123', '601'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-124',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-124', '132'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-125',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-125', 'aa8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-126',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-126', '4fd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-127',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-127', 'c25'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-128',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-128', '74e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-13',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-13', 'f73'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-14',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-14', '980'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-15',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-15', '0a5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-16',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-16', '6d1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-17',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-17', 'ff5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-18',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-18', 'd50'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-19',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-19', 'e13'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-2',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-2', '3bd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-20',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-20', '3ae'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-21',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-21', 'de6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-22',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-22', '991'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-23',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-23', '5df'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-24',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-24', 'e3f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-25',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-25', 'f10'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-26',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-26', '4ff'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-27',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-27', 'f1d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-28',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-28', '402'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-29',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-29', '30c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-3',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-3', 'fec'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-30',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-30', 'ff3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-31',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-31', '052'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-32',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-32', '025'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-33',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-33', '02d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-34',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-34', '73e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-35',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-35', '29f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-36',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-36', 'fea'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-37',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-37', '7f1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-38',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-38', '73c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-39',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-39', '035'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-4',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-4', 'b70'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-40',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-40', '6d2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-41',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-41', '2e8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-42',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-42', '23c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-43',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-43', '377'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-44',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-44', '217'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-45',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-45', '4e0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-46',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-46', '928'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-47',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-47', 'c68'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-48',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-48', '995'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-49',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-49', 'f02'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-5',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-5', '5b6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-50',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-50', '1b1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-51',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-51', '7e4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-52',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-52', 'd51'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-53',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-53', 'b8e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-54',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-54', '48b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-55',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-55', '859'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-56',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-56', '63e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-57',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-57', 'f9c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-58',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-58', '26f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-59',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-59', 'bfb'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-6',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-6', '91f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-60',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-60', 'df5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-61',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-61', 'ac3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-62',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-62', 'ab7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-63',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-63', '723'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-64',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-64', '48d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-65',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-65', '7b9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-66',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-66', 'a2d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-67',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-67', '1f6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-68',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-68', '3a3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-69',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-69', '0e8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-7',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-7', '330'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-70',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-70', '7ad'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-71',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-71', '85a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-72',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-72', '1e1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-73',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-73', '732'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-74',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-74', '6a1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-75',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-75', '4c1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-76',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-76', '29a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-77',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-77', 'bcb'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-78',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-78', 'd14'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-79',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-79', 'd24'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-8',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-8', 'fa6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-80',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-80', 'fc9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-81',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-81', '8fb'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-82',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-82', '1c6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-83',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-83', '6ce'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-84',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-84', 'f3a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-85',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-85', 'e7b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-86',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-86', '802'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-87',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-87', '74d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-88',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-88', '205'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-89',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-89', 'd4f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-9',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-9', 'db7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-90',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-90', 'b37'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-91',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-91', '09c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-92',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-92', '7ce'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-93',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-93', '322'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-94',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-94', 'ea1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-95',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-95', '91f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-96',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-96', 'fcf'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-97',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-97', 'fb5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-98',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-98', '93c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/valmiki-ramayan-yuddhakand-adhyay-99',
                component: ComponentCreator('/valmiki-ramayan-yuddhakand-adhyay-99', '60f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/veda-suktam-saraswathi-suktam-rigveda-samhita',
                component: ComponentCreator('/veda-suktam-saraswathi-suktam-rigveda-samhita', '64f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/veda-suktam-sri-ganesha-suktam-in-hindi',
                component: ComponentCreator('/veda-suktam-sri-ganesha-suktam-in-hindi', '1f2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/vishnu',
                component: ComponentCreator('/vishnu', 'b01'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/vishnu-chalisa',
                component: ComponentCreator('/vishnu-chalisa', 'a7c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/vishnu-palana',
                component: ComponentCreator('/vishnu-palana', '9e2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/vishnu-sahasranam',
                component: ComponentCreator('/vishnu-sahasranam', '4bf'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/vishnu-shahtra-namavali',
                component: ComponentCreator('/vishnu-shahtra-namavali', 'f36'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/vishnu-sri-lakshmi-narayana-ashtottara-shatanama-stotram',
                component: ComponentCreator('/vishnu-sri-lakshmi-narayana-ashtottara-shatanama-stotram', 'a41'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/vishnu-stavan-stotram',
                component: ComponentCreator('/vishnu-stavan-stotram', '9c6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/vishnu-stotra',
                component: ComponentCreator('/vishnu-stotra', 'b26'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/vishwakarma-chalisa',
                component: ComponentCreator('/vishwakarma-chalisa', 'edf'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/vishwanth-ashtak',
                component: ComponentCreator('/vishwanth-ashtak', '223'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/vithumauli-tu',
                component: ComponentCreator('/vithumauli-tu', '6e5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/vitthal',
                component: ComponentCreator('/vitthal', '91b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/vitthal-geeti',
                component: ComponentCreator('/vitthal-geeti', '601'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/vividha-brahma-stotram-deva-krutam',
                component: ComponentCreator('/vividha-brahma-stotram-deva-krutam', '91d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/vyanktesh-shahtra-namavali',
                component: ComponentCreator('/vyanktesh-shahtra-namavali', '465'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/vyanktesh-stotra',
                component: ComponentCreator('/vyanktesh-stotra', '0ca'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/yajsathi-kela-hota',
                component: ComponentCreator('/yajsathi-kela-hota', '569'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अंबेमाते-चे-भजन/आई-ग-अंबे-माते-तुझा-सोनिया',
                component: ComponentCreator('/अंबेमाते-चे-भजन/आई-ग-अंबे-माते-तुझा-सोनिया', 'f31'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अंबेमाते-चे-भजन/चांदण-चांदण-झाली-रात-एकवि',
                component: ComponentCreator('/अंबेमाते-चे-भजन/चांदण-चांदण-झाली-रात-एकवि', '002'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अंबेमाते-चे-भजन/तुने-मुझे-बुलाया-शेरा-वाल',
                component: ComponentCreator('/अंबेमाते-चे-भजन/तुने-मुझे-बुलाया-शेरा-वाल', 'a73'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अंबेमाते-चे-भजन/ये-हंसावरती-बसून-शारदे-मा',
                component: ComponentCreator('/अंबेमाते-चे-भजन/ये-हंसावरती-बसून-शारदे-मा', 'ccc'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग-दत्ताचे-अभंग/जनार्दनाचा-गुरु-हो-स्वाम',
                component: ComponentCreator('/अभंग-दत्ताचे-अभंग/जनार्दनाचा-गुरु-हो-स्वाम', '7dd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग-दत्ताचे-अभंग/दत्त-दर्शनाला-जायचं-जायच-da',
                component: ComponentCreator('/अभंग-दत्ताचे-अभंग/दत्त-दर्शनाला-जायचं-जायच-da', 'b95'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग-दत्ताचे-अभंग/नमन-माझे-गुरुराया-naman-majhe-gururaya',
                component: ComponentCreator('/अभंग-दत्ताचे-अभंग/नमन-माझे-गुरुराया-naman-majhe-gururaya', 'e04'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग-दत्ताचे-अभंग/निघालो-घेवून-दत्ताची-पाल',
                component: ComponentCreator('/अभंग-दत्ताचे-अभंग/निघालो-घेवून-दत्ताची-पाल', '556'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग-दत्ताचे-अभंग/प्राणीयासी-मंत्र-सोपा-दत',
                component: ComponentCreator('/अभंग-दत्ताचे-अभंग/प्राणीयासी-मंत्र-सोपा-दत', '7b4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/ॐ-कार-प्रधान-रूप-गणेशाचे-omkar-pradhan',
                component: ComponentCreator('/अभंग/ॐ-कार-प्रधान-रूप-गणेशाचे-omkar-pradhan', '4e3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/ॐ-कार-स्वरूपा-सद्गुरू-समर',
                component: ComponentCreator('/अभंग/ॐ-कार-स्वरूपा-सद्गुरू-समर', '615'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/अशी-चिक-मोत्यांची-माळ-होत',
                component: ComponentCreator('/अभंग/अशी-चिक-मोत्यांची-माळ-होत', '155'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/आज-सोनियाचा-दिनू-वर्षे-अम',
                component: ComponentCreator('/अभंग/आज-सोनियाचा-दिनू-वर्षे-अम', '7ac'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/आता-बोला-मुखाने-हरि-नाम-जय',
                component: ComponentCreator('/अभंग/आता-बोला-मुखाने-हरि-नाम-जय', 'd14'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/आधी-रचिली-पंढरी-मग-वैकुंठ',
                component: ComponentCreator('/अभंग/आधी-रचिली-पंढरी-मग-वैकुंठ', 'bf3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/आवडीने-भावे-हरिनाम-घेसी-aavadine-bhave',
                component: ComponentCreator('/अभंग/आवडीने-भावे-हरिनाम-घेसी-aavadine-bhave', '86a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/आवडे-हे-रूप-गोजिरे-सगुण-aavade-he-rup-gojire-sa',
                component: ComponentCreator('/अभंग/आवडे-हे-रूप-गोजिरे-सगुण-aavade-he-rup-gojire-sa', 'eae'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/उस-डोंगा-परी-रस-नोहे-डोंगा-us-d',
                component: ComponentCreator('/अभंग/उस-डोंगा-परी-रस-नोहे-डोंगा-us-d', 'b0c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/करितो-वंदना-गजानना-karito-vandana-gajanana-tumhi-hasat-nachat-ya-angan',
                component: ComponentCreator('/अभंग/करितो-वंदना-गजानना-karito-vandana-gajanana-tumhi-hasat-nachat-ya-angan', '14e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/कारे-देवा-उशीर-पारकेला-ka-re-deva-ushir-paar-ke',
                component: ComponentCreator('/अभंग/कारे-देवा-उशीर-पारकेला-ka-re-deva-ushir-paar-ke', '5c8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/कृपाळू-हा-पंढरीनाथ-krupalu-ha-pandhari-nath-majhya-vadilanche-daivat',
                component: ComponentCreator('/अभंग/कृपाळू-हा-पंढरीनाथ-krupalu-ha-pandhari-nath-majhya-vadilanche-daivat', '433'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/गजानना-गजानना-गणराया-gajanana-gajanana-ganaraya',
                component: ComponentCreator('/अभंग/गजानना-गजानना-गणराया-gajanana-gajanana-ganaraya', '515'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/घातली-रांगोळी-गुलालाची-स',
                component: ComponentCreator('/अभंग/घातली-रांगोळी-गुलालाची-स', 'b5a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/घेई-घेई-माझे-वाचे-गोड-नाम-व',
                component: ComponentCreator('/अभंग/घेई-घेई-माझे-वाचे-गोड-नाम-व', '3a6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/चंद्रभागेच्या-तिरी-उभा-म',
                component: ComponentCreator('/अभंग/चंद्रभागेच्या-तिरी-उभा-म', 'd3d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/जन-विजन-झाले-आम्हा-विठ्ठल',
                component: ComponentCreator('/अभंग/जन-विजन-झाले-आम्हा-विठ्ठल', 'ac4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/जय-जय-राम-राम-कृष्ण-हरी-jay-jay-ram-krushna-hari',
                component: ComponentCreator('/अभंग/जय-जय-राम-राम-कृष्ण-हरी-jay-jay-ram-krushna-hari', 'd57'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/ज्या-सुखा-कारणे-देव-वेडाव',
                component: ComponentCreator('/अभंग/ज्या-सुखा-कारणे-देव-वेडाव', 'a85'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/झाला-महार-पंढरीनाथा-jhala-mahar-pandharinath',
                component: ComponentCreator('/अभंग/झाला-महार-पंढरीनाथा-jhala-mahar-pandharinath', 'cec'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/टाळ-बोले-चिपळीला-नाच-माझ्',
                component: ComponentCreator('/अभंग/टाळ-बोले-चिपळीला-नाच-माझ्', 'f5a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/तुझा-माझा-करे-वैराकर-देवा-tujh',
                component: ComponentCreator('/अभंग/तुझा-माझा-करे-वैराकर-देवा-tujh', '1a5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/तुला-खांद्यावर-घेईन-तुला',
                component: ComponentCreator('/अभंग/तुला-खांद्यावर-घेईन-तुला', 'b7a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/तूच-सुखकर्ता-तूच-दुखहर्त',
                component: ComponentCreator('/अभंग/तूच-सुखकर्ता-तूच-दुखहर्त', '59a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/दुसरे-शिवाजी-होवून-गेले-ब',
                component: ComponentCreator('/अभंग/दुसरे-शिवाजी-होवून-गेले-ब', 'e56'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/देखोनिया-तुझ्या-रूपाचा-आ',
                component: ComponentCreator('/अभंग/देखोनिया-तुझ्या-रूपाचा-आ', '494'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/देव-इंद्रायणी-थांबला-dev-indrayani-thambala-dnyanoba-m',
                component: ComponentCreator('/अभंग/देव-इंद्रायणी-थांबला-dev-indrayani-thambala-dnyanoba-m', '7a1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/देव-माझा-विठू-सावळा-dev-majha-vithu-savala',
                component: ComponentCreator('/अभंग/देव-माझा-विठू-सावळा-dev-majha-vithu-savala', '8ae'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/देवा-तुझा-मी-सोनार-deva-tujha-mi-sonar',
                component: ComponentCreator('/अभंग/देवा-तुझा-मी-सोनार-deva-tujha-mi-sonar', 'ba6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/धन्य-अंजनी-सुता-अंजनीच्य',
                component: ComponentCreator('/अभंग/धन्य-अंजनी-सुता-अंजनीच्य', '7eb'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/नमन-माझे-गुरुराया-महाराज',
                component: ComponentCreator('/अभंग/नमन-माझे-गुरुराया-महाराज', '50b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/नमो-नमो-तुज-श्री-गणराया-namo-namo-tujh-shri-gan',
                component: ComponentCreator('/अभंग/नमो-नमो-तुज-श्री-गणराया-namo-namo-tujh-shri-gan', 'aac'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/नाम-गाऊ-नाम-घेऊ-नाम-विठोबा',
                component: ComponentCreator('/अभंग/नाम-गाऊ-नाम-घेऊ-नाम-विठोबा', '069'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/नाम-घेता-उठाउठी-होय-संसार',
                component: ComponentCreator('/अभंग/नाम-घेता-उठाउठी-होय-संसार', '258'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/नाम-घेता-तुझे-गोविंदा-मनी',
                component: ComponentCreator('/अभंग/नाम-घेता-तुझे-गोविंदा-मनी', '768'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/नाम-विठोबाचे-घ्यावे-मग-पा',
                component: ComponentCreator('/अभंग/नाम-विठोबाचे-घ्यावे-मग-पा', '12d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/पंढरीचा-विठ्ठल-कोणी-पहिल',
                component: ComponentCreator('/अभंग/पंढरीचा-विठ्ठल-कोणी-पहिल', '420'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/पांडुरंगा-मी-पतंग-तुझ्या',
                component: ComponentCreator('/अभंग/पांडुरंगा-मी-पतंग-तुझ्या', '5ce'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/प्रथम-तुला-वंदितो-कृपाळा-pratha',
                component: ComponentCreator('/अभंग/प्रथम-तुला-वंदितो-कृपाळा-pratha', 'b2b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/फिरत्या-चाकावरती-देसी-मा',
                component: ComponentCreator('/अभंग/फिरत्या-चाकावरती-देसी-मा', 'b9d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/बसून-कसा-राहीला-दगडावरी-basun-kasa-rahi',
                component: ComponentCreator('/अभंग/बसून-कसा-राहीला-दगडावरी-basun-kasa-rahi', 'eb5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/बोलावा-विठ्ठल-पाहावा-विठ',
                component: ComponentCreator('/अभंग/बोलावा-विठ्ठल-पाहावा-विठ', 'd46'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/भक्ती-वाचून-मुक्तीची-मज-ज',
                component: ComponentCreator('/अभंग/भक्ती-वाचून-मुक्तीची-मज-ज', '080'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/भगवा-झेंडा-फडकवीत-आला-आला-bhaga',
                component: ComponentCreator('/अभंग/भगवा-झेंडा-फडकवीत-आला-आला-bhaga', '00c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/माऊली-च-मूर्ती-विठ्ठलाची',
                component: ComponentCreator('/अभंग/माऊली-च-मूर्ती-विठ्ठलाची', '3ea'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/माऊली-च-मूर्ती-विठ्ठलाची-mavuli',
                component: ComponentCreator('/अभंग/माऊली-च-मूर्ती-विठ्ठलाची-mavuli', 'f2c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/माझिया-बोबडिया-बोला-चित्',
                component: ComponentCreator('/अभंग/माझिया-बोबडिया-बोला-चित्', '7e6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/माझे-माहेर-पंढरी-आहे-भिवर',
                component: ComponentCreator('/अभंग/माझे-माहेर-पंढरी-आहे-भिवर', '2de'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/माझे-माहेर-पंढरी-आहे-भिवर-2',
                component: ComponentCreator('/अभंग/माझे-माहेर-पंढरी-आहे-भिवर-2', 'd8e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/यारे-नाचू-प्रेमानांदे-वि',
                component: ComponentCreator('/अभंग/यारे-नाचू-प्रेमानांदे-वि', 'b45'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/रामकृष्ण-गोविंद-नारायण-ह',
                component: ComponentCreator('/अभंग/रामकृष्ण-गोविंद-नारायण-ह', 'be8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/रुपी-गुंतले-लोचन-पायी-स्थ',
                component: ComponentCreator('/अभंग/रुपी-गुंतले-लोचन-पायी-स्थ', '057'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/रूप-सावळे-सुंदर-rup-savale-sundar',
                component: ComponentCreator('/अभंग/रूप-सावळे-सुंदर-rup-savale-sundar', '439'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/लंबोदर-गिरीजा-नंदना-देवा-lambod',
                component: ComponentCreator('/अभंग/लंबोदर-गिरीजा-नंदना-देवा-lambod', 'de5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/विठ्ठल-आवडी-प्रेमे-भाव-हो',
                component: ComponentCreator('/अभंग/विठ्ठल-आवडी-प्रेमे-भाव-हो', '75d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/विठ्ठल-नामाची-शाळा-भरली-viththal-namach',
                component: ComponentCreator('/अभंग/विठ्ठल-नामाची-शाळा-भरली-viththal-namach', 'aed'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/विठ्ठल-पाहुणा-आला-माझ्या',
                component: ComponentCreator('/अभंग/विठ्ठल-पाहुणा-आला-माझ्या', '17d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/विठ्ठलाच्या-पायी-विट-झाल',
                component: ComponentCreator('/अभंग/विठ्ठलाच्या-पायी-विट-झाल', 'f25'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/वेढा-वेढा-रे-पंढरी-vedha-vedha-re-pandhari',
                component: ComponentCreator('/अभंग/वेढा-वेढा-रे-पंढरी-vedha-vedha-re-pandhari', 'ac5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/श्री-गणेशा-शारदा-करीशी-गा',
                component: ComponentCreator('/अभंग/श्री-गणेशा-शारदा-करीशी-गा', '702'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/सकळ-मंगळ-निधी-श्री-विठ्ठल',
                component: ComponentCreator('/अभंग/सकळ-मंगळ-निधी-श्री-विठ्ठल', '15b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/सभा-रंगणी-गण-गौवरी-चा-नाचत',
                component: ComponentCreator('/अभंग/सभा-रंगणी-गण-गौवरी-चा-नाचत', 'e39'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/सुखाचे-हे-नाम-आवडीने-गावे-sukha',
                component: ComponentCreator('/अभंग/सुखाचे-हे-नाम-आवडीने-गावे-sukha', '790'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/सुंदर-ते-ध्यान-उभे-विटेवर',
                component: ComponentCreator('/अभंग/सुंदर-ते-ध्यान-उभे-विटेवर', '028'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/सुंदर-ते-ध्यान-पहा-जाऊनी-sundar-te-dhya',
                component: ComponentCreator('/अभंग/सुंदर-ते-ध्यान-पहा-जाऊनी-sundar-te-dhya', '132'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/हरी-नाम-जो-जो-विसरला-तया-हस',
                component: ComponentCreator('/अभंग/हरी-नाम-जो-जो-विसरला-तया-हस', 'a3a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/हा-देवांचा-देव-गणपती-सर्व',
                component: ComponentCreator('/अभंग/हा-देवांचा-देव-गणपती-सर्व', '2b5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/हे-भॊळ्या-शंकरा-he-bholya-shankara',
                component: ComponentCreator('/अभंग/हे-भॊळ्या-शंकरा-he-bholya-shankara', '5ef'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/अभंग/हे-शिवशंकर-गिरीजा-तनया-गण',
                component: ComponentCreator('/अभंग/हे-शिवशंकर-गिरीजा-तनया-गण', '8e6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/गौवळण/देव-एका-पायाने-लंगडा-asa-kasa-bai-devacha-dev-thakada-dev-eka',
                component: ComponentCreator('/गौवळण/देव-एका-पायाने-लंगडा-asa-kasa-bai-devacha-dev-thakada-dev-eka', '391'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/गौवळण/नको-वाजवू-श्री-हरी-मुरली-nako-vajavu-sh',
                component: ComponentCreator('/गौवळण/नको-वाजवू-श्री-हरी-मुरली-nako-vajavu-sh', 'e8e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/गौवळण/वनमाळी-वनमाळी-वनमाळी-vanmali-vanmali-vanmali',
                component: ComponentCreator('/गौवळण/वनमाळी-वनमाळी-वनमाळी-vanmali-vanmali-vanmali', '13e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/ब्रम्हा-चे-भजन/ब्रम्हा-विष्णू-आणि-महेश-स',
                component: ComponentCreator('/ब्रम्हा-चे-भजन/ब्रम्हा-विष्णू-आणि-महेश-स', '079'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/भैरवी/आम्ही-बी-घडलो-तुम्ही-बी-घड',
                component: ComponentCreator('/भैरवी/आम्ही-बी-घडलो-तुम्ही-बी-घड', '1e2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/भैरवी/किती-आनंदी-आनंद-या-झोपडीत',
                component: ComponentCreator('/भैरवी/किती-आनंदी-आनंद-या-झोपडीत', '9c8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/भैरवी/जुनी-पुराणी-नाव-माझी-किना',
                component: ComponentCreator('/भैरवी/जुनी-पुराणी-नाव-माझी-किना', '0e1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/रुपावली/तुझे-रूप-पाहता-देवा-सुख-झा',
                component: ComponentCreator('/रुपावली/तुझे-रूप-पाहता-देवा-सुख-झा', '876'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/विठ्ठलाचे-भजन/अबीर-गुलाल-उधळीत-रंग-नाथा',
                component: ComponentCreator('/विठ्ठलाचे-भजन/अबीर-गुलाल-उधळीत-रंग-नाथा', '98d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/विठ्ठलाचे-भजन/अवघे-गरजे-पंढरपूर-चालला-न',
                component: ComponentCreator('/विठ्ठलाचे-भजन/अवघे-गरजे-पंढरपूर-चालला-न', 'd3a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/विठ्ठलाचे-भजन/कानडा-राजा-पंढरीचा-kanda-raja-pandharicha',
                component: ComponentCreator('/विठ्ठलाचे-भजन/कानडा-राजा-पंढरीचा-kanda-raja-pandharicha', '9ec'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/विठ्ठलाचे-भजन/धरीला-पंढरीचा-चोर-गळा-बां',
                component: ComponentCreator('/विठ्ठलाचे-भजन/धरीला-पंढरीचा-चोर-गळा-बां', '39a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/विठ्ठलाचे-भजन/नाम-घेता-उठाउठी-nam-gheta-uthauthi',
                component: ComponentCreator('/विठ्ठलाचे-भजन/नाम-घेता-उठाउठी-nam-gheta-uthauthi', 'cec'),
                exact: true,
                sidebar: "tutorialSidebar"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
